import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setEmployeeProfileDATASActions,
  SetBasiformsID,
  SetIdVeriications,
  SetAddressId,
  setBankDetailsId,
  SetEducationDetails,
  SetPreviousEmployeeID,
  setfamliydetailsid,
  SetDeclarationId,
  SetEsiFormIdActions,
  SetJobOfferID,
  SetActiveTabs,
  getSideBarfilesActions,
  SetApprovalCallsActions,
  settheDateOfjoining,
  setTheOnboardPhoneNumber, //for get the phone number,
  setTheOnboarderdetailsReportActions, /// to get the payroll names,
  sethtmlformatpdfdownoadActions,
  SetTheJoiningDateCall,
  CreateResponse_store,
  setTheSignaturePadNumberSet,
  SETBASICFORMcreatedetails,
  setTheFirstNames,
  setTheActionForOtpPhoneNumbers, ///----Phone---Number----
  setTheActionForOtpwithPhoneNumbers,
  SetSignaturePops,
  settheBankHolderName,
  setTheActionResentForOtpPhoneNumbers,
  settheJobinfoBranchEmployeeProfile,
  setthejobinformationroleID,
  setTheTransactionID,
  setbankCounts,
  settheEmployeeFormFilled, ///---- it  will defined the boolean value , by based it will  make it as edit or not
  gettheRegeneratePdfAction,
  setTheAadharBackSideImageDatas,
  setTHnUMBERSRESPONSES,
  setTheEsignatureCodes,
  setTheAllFormPdf,
  SetRemainderMailCallAction,
  gettheStoretheRejoiningActions,
} from "../../../Redux/Slice";
import "../../../StyleSheet/MainComponent/Management/EmployeeProfile.scss";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pending from "../../../Assets/AppComponent/icons/Group 145.svg";
import ArrowIcons from "../../../Assets/AppComponent/Arrow/Vector .svg";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import emptycircle from "../../../Assets/AppComponent/Ellipse 4.png";
import jsPDF from "jspdf";
import ActiveEmc from "../../../Assets/AppComponent/Group 309.svg";
import InActiveEmc from "../../../Assets/AppComponent/Group 309 (1).svg";

import { toast } from "react-toastify";
import { pdfgetlistapi } from "../../../text/apidata";
import PdfViwers from "./PdfView";
import { faIR } from "date-fns/locale";
import { Label } from "recharts";
// import PdfViewer from "./PdfView";
// import { PDFViewer } from '@react-pdf/renderer';
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import Lettersexports from "./Letterexports";

const EMployeeProfiles = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const Swal = require("sweetalert2");
  //  window.Swal = Swal;
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [UserName, setUserName] = useState("");
  const [RoleName, setRoleNames] = useState("");
  const [EmpActive, setEmpActive] = useState();

  const [Delaration, setDeclarations] = useState();
  const [LastName, setLastName] = useState("");
  const [BasicForm, setBasicForm] = useState();
  const [ESiForm, setEsiForms] = useState();
  const [FamlityDetails, setFamDetails] = useState();
  const [Verify, setVerify] = useState();
  const [PreviouEmp, setPreviEmp] = useState();
  const [Education, setEducation] = useState();
  const [BankDetail, setBankDetail] = useState();
  const [JobOffer, setJobOffer] = useState();
  const [AdderDeatils, setAdderDetails] = useState();
  const navigate = useNavigate();
  const [Approvel, setApprovel] = useState(false);
  const [RMADMIN, setRMADMN] = useState(false);
  const [whatsApp, setWhatsApp] = useState(false);
  const [createEmployee, setCreateEmployee] = useState();
  let payloads = {
    search: "",
    page_size: 10,
    page: 1,
    ids: state.ClientBranchIDs.EmployeeDetailsProfile,
    is_pending: state.ClientBranchIDs.IS_pendingDetails,
  };

  const [open, setopen] = useState(false);
  const UserData = useSelector((state) => state.users.UserData);
  const [SubRoleList, setSubRoleList] = useState();

  const [TabNmaes, setTabnames] = useState({ clientname: "", branchname: "" });
  const [idverificationsID, setdVerifications] = useState(false);

  const [Bank, setBank] = useState(false);
  const [UserImage, setUserimage] = useState(null);

  const [DateOfJoing, setdateOf] = useState();
  const [Onboarder, setOnboader] = useState([]);
  const [Payroll, setpayroll] = useState([]);
  const [Rm, setRm] = useState([]);
  const [hrApproval, setHrApproval] = useState([]);
  const [token, setTokens] = useState(null);
  const [ManagerList, setManagerList] = useState("");
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [result, setResult] = useState(null); // Define 'result' state

  const [PhonerNumber, setPhoneNumber] = useState();

  const [StatusCode, setStatusCode] = useState(false);
  ///---display the rejoining based in the , approve employee , and when there have the id in the job_description in letter id
  const [RejectionDisplay, setrejectiondisplay] = useState(false);
  const [RejoinBool, setRejoingBool] = useState(false);

  const organization = useSelector(
    (state) => state.NumberCounts.selectedOnoardClient,
  );

  useEffect(() => {
    dispatch(SetSignaturePops(false));
  }, []);

  ///---rendring the useEffect to find the status
  // useEffect(() => {
  //   if (
  //     state.ManPowerActiveDataTabs.statusCOdeForESign != undefined &&
  //     state.ManPowerActiveDataTabs.statusCOdeForESign != null &&
  //     state.ManPowerActiveDataTabs.statusCOdeForESign == 200
  //   ) {
  //     setStatusCode(true);
  //   } else {
  //     setStatusCode(false);
  //   }
  // }, [state.ManPowerActiveDataTabs.statusCOdeForESign]);

  // console.log(state.NumberCounts.ZONEobjects ,"ZONEobjects" );

  useEffect(() => {
    if (
      state.NeededdatasListed.clientNameList &&
      typeof state.NeededdatasListed.clientNameList === "string"
    ) {
      const maxLength = 10; // Set your desired maximum length
      const ellipsis = "..."; // Set your ellipsis string

      const truncatedClientName =
        state.NeededdatasListed.clientNameList.length > maxLength
          ? `${state.NeededdatasListed.clientNameList.substring(
            0,
            maxLength,
          )}${ellipsis}`
          : state.NeededdatasListed.clientNameList;
      console.log("Truncated Client Name:", truncatedClientName);

      const truncatedBranchNameName =
        state.NeededdatasListed.BranchNameListed.length > maxLength
          ? `${state.NeededdatasListed.BranchNameListed.substring(
            0,
            maxLength,
          )}${ellipsis}`
          : state.NeededdatasListed.BranchNameListed;

      setTabnames({
        ...TabNmaes,
        clientname: truncatedClientName,
        branchname: truncatedBranchNameName,
      });
      // Use `truncatedClientName` in your component
      console.log("Truncated Client Name:", truncatedClientName);
    } else {
      // Handle the case when clientNameList is undefined or not a string
      console.log("Client Name List is undefined or not a string");
    }
  }, [state.NeededdatasListed]);

  useEffect(() => {
    if (state.users.UserData.data != undefined) {
    }
    if (UserData.session) {
      if (UserData.data != undefined && UserData.data != null) {
        setSubRoleList(UserData.data.sub_role);
      }
    }
  }, [UserData]);
  useEffect(() => {
    if (
      state.EmployeeProfile.EmployeeProfileList != "" &&
      state.EmployeeProfile.EmployeeProfileList != undefined &&
      state.EmployeeProfile.EmployeeProfileList != null &&
      state.EmployeeProfile.EmployeeProfileList.approved_status != undefined &&
      state.EmployeeProfile.EmployeeProfileList.approved_status != null
    ) {
      const OnboaderData = [];
      const OnboarderDataListed = [];
      const RmOnboarder = [];
      const HRApproval = [];
      console.log(
        state.EmployeeProfile.EmployeeProfileList,
        "dajksdjkasjkdjkasda",
      );
      state.EmployeeProfile.EmployeeProfileList.approved_status.map((item) => {
        console.log(item.create_user, "asidupoasd paosdaosidoasid ");

        if (item.user_type == "payroll") {
          if (
            // item.create_user != "" &&
            // item.create_user != null &&
            // item.create_user != undefined
            item.approver_id != "" &&
            item.approver_id != null &&
            item.approver_id != undefined
          ) {
            OnboaderData.push({
              // name: item.create_user.first_name,
              name: item.approver_id?.first_name,
              status: item.status,
              Createdate: item.created_at,
              reason: item.decline_message,
            });
          }
        }

        if (item.user_type == "onboard") {
          if (
            // item.create_user != "" &&
            // item.create_user != null &&
            // item.create_user != undefined
            item.approver_id != "" &&
            item.approver_id != null &&
            item.approver_id != undefined
          ) {
            OnboarderDataListed.push({
              // name: item.create_user.first_name,
              name: item.approver_id?.first_name,
              status: item.status,
              Createdate: item.created_at,
              reason: item.decline_message,
            });
          }
        }

        if (item.user_type == "manager") {
          if (
            // item.create_user != "" &&
            // item.create_user != null &&
            // item.create_user != undefined

            item.approver_id != "" &&
            item.approver_id != null &&
            item.approver_id != undefined
          ) {
            RmOnboarder.push({
              // name: item.create_user.first_name,
              name: item.approver_id?.first_name,
              status: item.status,
              Createdate: item.created_at,
              reason: item.decline_message,
            });
          }
        }
        if (item.user_type == "HR") {
          if (
            // item.create_user != "" &&
            // item.create_user != null &&
            // item.create_user != undefined

            item.approver_id != "" &&
            item.approver_id != null &&
            item.approver_id != undefined
          ) {
            HRApproval.push({
              // name: item.create_user.first_name,
              name: item.approver_id?.first_name,
              status: item.status,
              Createdate: item.created_at,
              reason: item.decline_message,
            });
          }
        }
      });

      console.log(
        state.EmployeeProfile.EmployeeProfileList.manager_id,
        "EmployeeProfileList",
      );

      setpayroll(OnboaderData);
      setOnboader(OnboarderDataListed);
      setRm(RmOnboarder);
      setHrApproval(HRApproval);
    } else {
      setpayroll([]);
      setOnboader([]);
      setRm([]);
      setHrApproval([]);
    }
    if (state.EmployeeProfile.EmployeeProfileList.manager_id != null) {
      state.EmployeeProfile.EmployeeProfileList.manager_id != null &&
        setManagerList(
          state.EmployeeProfile.EmployeeProfileList.manager_id.first_name,
        );
    } else if (state.EmployeeProfile.EmployeeProfileList.manager_id == null) {
      setManagerList("");
    }
  }, [state.EmployeeProfile.EmployeeProfileList]);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };
  useEffect(() => {
    if (state.users.UserData.data != undefined) {
      if (UserData.session) {
        setTokens(UserData.session.token);

        // console.log(state.SideBarFiles.Role.toLowerCase().includes("field agent") , "role");
      }
    }
  }, [UserData]);
  useEffect(() => {
    dispatch(setTheSignaturePadNumberSet(1));
  }, []);
  useEffect(() => {
    if (
      state.ClientBranchIDs.EmployeeDetailsProfile != undefined &&
      state.ClientBranchIDs.EmployeeDetailsProfile != ""
    ) {
      dispatch(setEmployeeProfileDATASActions(payloads));
    }
  }, [Approvel, RMADMIN, state.ESIdetails.ESIDATAS]);
  console.log(
    state.EmployeeProfile.EmployeeProfileList,
    "sodisoidupdoAIS POAS AS",
    state.EmployeeProfile.EmployeeProfileList != "" &&
    state.EmployeeProfile.EmployeeProfileList != null &&
    state.EmployeeProfile.EmployeeProfileList.id != undefined &&
    state.ClientBranchIDs.EmployeeDetailsProfile != "",
  );

  useEffect(() => {
    if (
      state.EmployeeProfile.EmployeeProfileList != "" &&
      state.EmployeeProfile.EmployeeProfileList != null &&
      state.EmployeeProfile.EmployeeProfileList.id != undefined &&
      state.ClientBranchIDs.EmployeeDetailsProfile != ""
    ) {
      if (
        (state.EmployeeProfile.EmployeeProfileList.user_id.first_name !=
          undefined &&
          state.EmployeeProfile.EmployeeProfileList.user_id.first_name !=
          null) ||
        state.EmployeeProfile.EmployeeProfileList.user_id.last_name != undefined
      ) {
        dispatch(
          SETBASICFORMcreatedetails(
            state.EmployeeProfile.EmployeeProfileList.id,
          ),
        );
        //  console.log(state.EmployeeProfile.EmployeeProfileList.id , "state.EmployeeProfile.EmployeeProfileList.id");

        setUserName(
          state.EmployeeProfile.EmployeeProfileList.user_id.first_name.toUpperCase(),
        );
        setLastName(
          state.EmployeeProfile.EmployeeProfileList?.user_id?.last_name?.toUpperCase(),
        );
      }

      // if(state.EmployeeProfile.EmployeeProfileList != "" && state.EmployeeProfile.EmployeeProfileList != null ){
      //   if(state.EmployeeProfile.EmployeeProfileList != undefined && state.EmployeeProfile.EmployeeProfileList != ""
      //     &&
      //     state.EmployeeProfile.EmployeeProfileList.client_id != null &&
      //     state.EmployeeProfile.EmployeeProfileList.client_id != undefined

      //    ){
      //     dispatch(settheJobinfoBranchEmployeeProfile({value:state.EmployeeProfile.EmployeeProfileList.client_id.id,label:state.EmployeeProfile.EmployeeProfileList.client_id.client_name}))
      //    }
      //   }///---job information inclient id

      if (
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.user_id != null &&
        state.EmployeeProfile.EmployeeProfileList.user_id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.is_pending == false &&
        state.EmployeeProfile.EmployeeProfileList.job_description != null &&
        state.EmployeeProfile.EmployeeProfileList.job_description !=
        undefined &&
        state.EmployeeProfile.EmployeeProfileList.job_description.letter_id !=
        undefined &&
        state.EmployeeProfile.EmployeeProfileList.job_description.letter_id !=
        null &&
        state.EmployeeProfile.EmployeeProfileList.job_description.letter_id !=
        null &&
        state.EmployeeProfile.EmployeeProfileList.job_description.letter_id !=
        undefined
      ) {
        setrejectiondisplay(true);
      } else if (
        state.EmployeeProfile.EmployeeProfileList == "" ||
        state.EmployeeProfile.EmployeeProfileList.id ||
        (undefined &&
          state.EmployeeProfile.EmployeeProfileList.user_id == null &&
          // state.EmployeeProfile.EmployeeProfileList.user_id == undefined &&
          state.EmployeeProfile.EmployeeProfileList.is_pending != false) ||
        state.EmployeeProfile.EmployeeProfileList.job_description == null ||
        state.EmployeeProfile.EmployeeProfileList.job_description ==
        undefined ||
        state.EmployeeProfile.EmployeeProfileList.job_description.letter_id ==
        null ||
        state.EmployeeProfile.EmployeeProfileList.job_description.letter_id ==
        undefined
      ) {
        setrejectiondisplay(false);
      }

      if (state.EmployeeProfile.EmployeeProfileList.address_details == null) {
        dispatch(setTheAadharBackSideImageDatas([]));
      }

      /// it will store the , is_pending values
      dispatch(
        settheEmployeeFormFilled(
          state.EmployeeProfile.EmployeeProfileList.is_pending,
        ),
      );
      setRejoingBool(
        state.EmployeeProfile.EmployeeProfileList.is_pending == true
          ? true
          : false,
      );
      setDeclarations(
        state.EmployeeProfile.EmployeeProfileList.is_declaration_form,
      );
      setBasicForm(state.EmployeeProfile.EmployeeProfileList.is_basic_info);
      setEsiForms(state.EmployeeProfile.EmployeeProfileList.is_esi_form);
      // setFamDetails(
      //   state.EmployeeProfile.EmployeeProfileList.is_family_details
      // );
      setVerify(state.EmployeeProfile.EmployeeProfileList.is_id_verification);
      setPreviEmp(
        state.EmployeeProfile.EmployeeProfileList.is_previous_employee,
      );
      setEducation(
        state.EmployeeProfile.EmployeeProfileList.is_education_details,
      );
      setBankDetail(state.EmployeeProfile.EmployeeProfileList.is_bank_details);
      setJobOffer(state.EmployeeProfile.EmployeeProfileList.is_job_description);
      setAdderDetails(
        state.EmployeeProfile.EmployeeProfileList.is_address_details,
      );
      setRoleNames(state.EmployeeProfile.EmployeeProfileList.user_id.user_uid);
      setEmpActive(state.EmployeeProfile.EmployeeProfileList.user_id.is_active);
      if (
        state.EmployeeProfile.EmployeeProfileList.user_id.profile_image != null
      ) {
        setUserimage(
          state.EmployeeProfile.EmployeeProfileList.user_id.profile_image
            .media_url,
        );
      }

      if (
        state.EmployeeProfile.EmployeeProfileList != "" &&
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList.basic_info != null &&
        state.EmployeeProfile.EmployeeProfileList.basic_info != undefined &&
        state.EmployeeProfile.EmployeeProfileList.basic_info.aadhar_number !=
        undefined &&
        state.EmployeeProfile.EmployeeProfileList.basic_info.aadhar_number !=
        null &&
        state.EmployeeProfile.EmployeeProfileList.basic_info.aadhar_number != ""
      ) {
        dispatch(
          setTHnUMBERSRESPONSES(
            state.EmployeeProfile.EmployeeProfileList.basic_info.aadhar_number,
          ),
        );
      }
      if (
        // state.NumberCounts.Editable == 1 &&
        state.EmployeeProfile.EmployeeProfileList != "" &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList.is_bank_details != null &&
        state.EmployeeProfile.EmployeeProfileList.is_bank_details != undefined
      ) {
        ///---for the bank verifications
        dispatch(
          CreateResponse_store(
            state.EmployeeProfile.EmployeeProfileList.is_bank_details,
          ),
        );
      }

      //  console.log(state.EmployeeProfile.EmployeeProfileList , "EmployeeProfileList");

      if (
        state.EmployeeProfile.EmployeeProfileList.basic_info != null &&
        state.EmployeeProfile.EmployeeProfileList.basic_info != undefined &&
        state.EmployeeProfile.EmployeeProfileList.basic_info.phone_number !=
        null
      ) {
        //. get the phone number for the Esi , Sign
        dispatch(
          setTheOnboardPhoneNumber(
            state.EmployeeProfile.EmployeeProfileList.basic_info.phone_number,
          ),
        );
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.job_description !=
        undefined &&
        state.EmployeeProfile.EmployeeProfileList.job_description != null &&
        state.EmployeeProfile.EmployeeProfileList.job_description
          .designation_id != null &&
        state.EmployeeProfile.EmployeeProfileList.job_description
          .designation_id != undefined
      ) {
        dispatch(
          setthejobinformationroleID(
            state.EmployeeProfile.EmployeeProfileList.job_description
              .designation_id,
          ),
        );
      }

      if (
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList.esi_form != null &&
        state.EmployeeProfile.EmployeeProfileList.esi_form != undefined &&
        state.EmployeeProfile.EmployeeProfileList.esi_form.date_of_joining !=
        undefined &&
        state.EmployeeProfile.EmployeeProfileList.esi_form.date_of_joining !=
        null &&
        state.EmployeeProfile.EmployeeProfileList.esi_form.date_of_joining != ""
      ) {
        setdateOf(
          state.EmployeeProfile.EmployeeProfileList.esi_form.date_of_joining,
        );

        // console.log(
        //   state.EmployeeProfile.EmployeeProfileList.esi_form.date_of_joining,
        //   "esi_form"
        // );
        dispatch(
          settheDateOfjoining(
            state.EmployeeProfile.EmployeeProfileList.esi_form.date_of_joining,
          ),
        );
      }
      // if (
      //   state.ClientBranchIDs.EmployeeDetailsProfile != "" &&
      //   state.ClientBranchIDs.EmployeeDetailsProfile.create_employee != null &&
      //   state.ClientBranchIDs.EmployeeDetailsProfile.create_employee !=
      //     undefined
      // ) {
      //   setApprovel(true);
      // }

      if (
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.ClientBranchIDs.EmployeeDetailsProfile != "" &&
        state.ClientBranchIDs.EmployeeDetailsProfile.job_description !=
        undefined &&
        state.ClientBranchIDs.EmployeeDetailsProfile.job_description != null &&
        state.ClientBranchIDs.EmployeeDetailsProfile.job_description
          .joining_date == null
      ) {
        ///--if--its--null --make it as false
        setCreateEmployee(
          //  state.EmployeeProfile.EmployeeProfileList.create_employee
          false,
        );
      }

      if (
        state.EmployeeProfile.EmployeeProfileList != "" &&
        state.EmployeeProfile.EmployeeProfileList.is_id_verification != null &&
        state.EmployeeProfile.EmployeeProfileList.is_id_verification !=
        undefined
      ) {
        setdVerifications(
          state.EmployeeProfile.EmployeeProfileList.is_id_verification,
        );
      }

      if (
        state.EmployeeProfile.EmployeeProfileList != "" &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList.is_bank_details != null &&
        state.EmployeeProfile.EmployeeProfileList.is_bank_details != undefined
      ) {
        setBank(state.EmployeeProfile.EmployeeProfileList.is_bank_details);
        // setWhatsApp(true);
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.ClientBranchIDs.EmployeeDetailsProfile != "" &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList.create_employee != null &&
        state.EmployeeProfile.EmployeeProfileList.create_employee != undefined
      ) {
        setCreateEmployee(
          state.EmployeeProfile.EmployeeProfileList.create_employee,
        );
      }
      if (
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList.is_pending == false &&
        // !state.EmployeeProfile.EmployeeProfileList.is_pending &&
        state.EmployeeProfile.EmployeeProfileList.job_description !=
        undefined &&
        state.EmployeeProfile.EmployeeProfileList.job_description != null &&
        state.EmployeeProfile.EmployeeProfileList.job_description.letter_id !=
        null &&
        state.EmployeeProfile.EmployeeProfileList.job_description.letter_id !=
        undefined
      ) {
        setApprovel(true);
        setRMADMN(false);
      } else {
        setApprovel(false);
        setRMADMN(false);
      }
      //  if(        state.EmployeeProfile.EmployeeProfileList != undefined &&
      //   state.EmployeeProfile.EmployeeProfileList.job_description ==
      //     undefined ||
      //   state.EmployeeProfile.EmployeeProfileList.job_description == null &&
      //   state.EmployeeProfile.EmployeeProfileList.job_description.letter_id ==
      //     null ||
      //   state.EmployeeProfile.EmployeeProfileList.job_description.letter_id ==
      //     undefined){
      //       setRMADMN(true)
      //     }

      if (
        state.EmployeeProfile.EmployeeProfileList.whatsapp_verify != null &&
        state.EmployeeProfile.EmployeeProfileList.whatsapp_verify != undefined
      ) {
        setWhatsApp(state.EmployeeProfile.EmployeeProfileList.whatsapp_verify);
        // setWhatsApp(true);
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.is_pending != null &&
        state.EmployeeProfile.EmployeeProfileList.is_pending != undefined &&
        state.EmployeeProfile.EmployeeProfileList.is_decline != null &&
        state.EmployeeProfile.EmployeeProfileList.is_decline != undefined &&
        state.EmployeeProfile.EmployeeProfileList.is_decline == false &&
        state.EmployeeProfile.EmployeeProfileList.is_pending == false
      ) {
        setRMADMN(true);
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.basic_info != null &&
        state.EmployeeProfile.EmployeeProfileList.basic_info != undefined
        //   &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetBasiformsID(
            state.EmployeeProfile.EmployeeProfileList.basic_info.id,
          ),
        );
      } ///---to--make ---as readonly
      else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList == "" &&
        state.EmployeeProfile.EmployeeProfileList.basic_info == null
      ) {
        dispatch(SetBasiformsID(""));
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.address_details != null &&
        state.EmployeeProfile.EmployeeProfileList.address_details != undefined
        //   &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetAddressId(
            state.EmployeeProfile.EmployeeProfileList.address_details.id,
          ),
        );
      } else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList.address_details == null ||
        state.EmployeeProfile.EmployeeProfileList.address_details == undefined
      ) {
        dispatch(SetAddressId(""));
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.job_description != null &&
        state.EmployeeProfile.EmployeeProfileList.job_description != undefined
        // &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetJobOfferID(
            state.EmployeeProfile.EmployeeProfileList.job_description.id,
          ),
        );
      } ///---for---readonly
      else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList.job_description == null &&
        state.EmployeeProfile.EmployeeProfileList.job_description == undefined
      ) {
        dispatch(SetJobOfferID(""));
      } ///-----edit or view

      if (
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList.id_verification != null &&
        state.EmployeeProfile.EmployeeProfileList.id_verification !=
        undefined &&
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.id_verification.id !=
        undefined
        //    &&
        // state.NumberCounts.Editable != 2
      ) {
        if (
          state.EmployeeProfile.EmployeeProfileList.basic_info != null &&
          state.EmployeeProfile.EmployeeProfileList.basic_info != undefined
        ) {
          dispatch(
            SetBasiformsID(
              state.EmployeeProfile.EmployeeProfileList.basic_info.id,
            ),
          );
        }

        if (
          state.EmployeeProfile.EmployeeProfileList.address_details != null &&
          state.EmployeeProfile.EmployeeProfileList.address_details != undefined
        ) {
          dispatch(
            SetAddressId(
              state.EmployeeProfile.EmployeeProfileList.address_details.id,
            ),
          );
        }
        dispatch(
          SetIdVeriications(
            state.EmployeeProfile.EmployeeProfileList.id_verification.id,
          ),
        );
      }

      if (
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList.bank_details != null &&
        state.EmployeeProfile.EmployeeProfileList.bank_details != undefined &&
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.bank_details != undefined
        //   &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          setBankDetailsId(
            state.EmployeeProfile.EmployeeProfileList.bank_details.id,
          ),
        );
        dispatch(
          settheBankHolderName(
            state.EmployeeProfile.EmployeeProfileList.bank_details
              .account_holder_name,
          ),
        );
      } else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList.bank_details == null &&
        state.EmployeeProfile.EmployeeProfileList.bank_details == undefined &&
        state.EmployeeProfile.EmployeeProfileList.bank_details == undefined
      ) {
        dispatch(setBankDetailsId(""));
        dispatch(setTheTransactionID(""));
        dispatch(setbankCounts(""));
      }

      if (
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList.education_details != null &&
        state.EmployeeProfile.EmployeeProfileList.education_details !=
        undefined &&
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.education_details.id !=
        undefined
        //    &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetEducationDetails(
            state.EmployeeProfile.EmployeeProfileList.education_details.id,
          ),
        );
      } else if (
        // state.NumberCounts.Editable == 2 &&
        (state.EmployeeProfile.EmployeeProfileList != null &&
          state.EmployeeProfile.EmployeeProfileList.education_details ==
          null) ||
        state.EmployeeProfile.EmployeeProfileList.education_details ==
        undefined ||
        state.EmployeeProfile.EmployeeProfileList.education_details.id == ""
      ) {
        dispatch(SetEducationDetails(""));
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.employee_previous != null &&
        state.EmployeeProfile.EmployeeProfileList.employee_previous != undefined
        //    &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetPreviousEmployeeID(
            state.EmployeeProfile.EmployeeProfileList.employee_previous.id,
          ),
        );
      } else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList.employee_previous == null &&
        state.EmployeeProfile.EmployeeProfileList.employee_previous == undefined
      ) {
        dispatch(SetPreviousEmployeeID(""));
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.declaration_form != null &&
        state.EmployeeProfile.EmployeeProfileList.declaration_form != undefined
        //  &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetDeclarationId(
            state.EmployeeProfile.EmployeeProfileList.declaration_form.id,
          ),
        );
      } else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList.declaration_form == null ||
        state.EmployeeProfile.EmployeeProfileList.declaration_form == undefined
      ) {
        dispatch(SetDeclarationId(""));
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.esi_form != null &&
        state.EmployeeProfile.EmployeeProfileList.esi_form != undefined
        //   &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetEsiFormIdActions(
            state.EmployeeProfile.EmployeeProfileList.esi_form.id,
          ),
        );

        // navigate("/formtab");
      } //---reaad--only
      else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList.esi_form == null ||
        state.EmployeeProfile.EmployeeProfileList.esi_form == undefined
      ) {
        dispatch(SetEsiFormIdActions(""));

        // navigate("/formtab");
      }

      if (
        state.EmployeeProfile.EmployeeProfileList != "" &&
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList.user_id != null &&
        state.EmployeeProfile.EmployeeProfileList.user_id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.user_id.first_name != "" &&
        state.EmployeeProfile.EmployeeProfileList.user_id.first_name !=
        undefined
      ) {
        dispatch(
          setTheFirstNames(
            state.EmployeeProfile.EmployeeProfileList.user_id.first_name,
          ),
        );
      }
    }
    // console.log(
    //   BankDetail,r
    //   "jljl",
    //   state.EmployeeProfile.EmployeeProfileList.id
    // );
  }, [
    state.EmployeeProfile.EmployeeProfileList,
    state.BasicFormCreated.user_ID,
    state.FormsIDList.ActiveTabs,
    state.ClientBranchIDs.EmployeeDetailsProfile,
  ]);

  // useEffect(()=>{
  //   if(state.EmployeeProfile.EmployeeProfileList != "" && state.EmployeeProfile.EmployeeProfileList != undefined &&
  //     state.EmployeeProfile.EmployeeProfileList != null
  //   ){
  //   dispatch(setTheAllFormPdf(state.EmployeeProfile.EmployeeProfileList.create_employee))
  //   }
  // },[state.EmployeeProfile.EmployeeProfileList])

  // console.log(state.EmployeeProfile.EmployeeProfileList , "EmployeeProfileList" );

  const HandleVerify = () => {
    // if(SubRoleList == 0){
    Swal.fire({
      title: "Do you want to  Verify?",
      // text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",
      confirmButtonText: "Yes, Verify it!",
    }).then((result) => {
      if (result.isConfirmed) {
        console.log(state.EmployeeProfile.EmployeeProfileList, "userId");
        if (
          state.EmployeeProfile.EmployeeProfileList != undefined ||
          (state.EmployeeProfile.EmployeeProfileList != null &&
            state.EmployeeProfile.EmployeeProfileList.lenght > 0 &&
            state.EmployeeProfile.EmployeeProfileList.user_id != undefined &&
            state.EmployeeProfile.EmployeeProfileList.user_id.id != undefined)
        ) {
          const payload = {
            UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
            //is_pending: true,
            is_pending: SubRoleList == 0 ? true : false,
            is_decline: false, ///is_decline :have to be true when the Rm is need to approve
            create_employee: true,
            Decline: 0,
            payroll_approved:
              SubRoleList == 0 || SubRoleList == 3 ? true : true,
          };

          console.log(SubRoleList, "SubRoleList", payload);

          dispatch(SetApprovalCallsActions(payload));
          if (SubRoleList == 1 || SubRoleList == 3) {
            navigate("/verifystatus");
          } else {
            navigate("/employeeVerifylist");
          }
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };

  const HandleRMpay = () => {
    if (SubRoleList == 1 || SubRoleList == 3) {
      Swal.fire({
        title: "Do you want to verify?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f26639",
        cancelButtonColor: "#F69338",
        confirmButtonText: "Yes, verify it!",
        html: `
        <div>
          <input type="checkbox" id="sendOfferLetter" />
          <label for="sendOfferLetter">Send offer letter via WhatsApp</label>
        </div>
      `,
      }).then((result) => {
        if (result.isConfirmed) {
          const sendOfferLetter =
            document.getElementById("sendOfferLetter").checked;

          console.log(state.EmployeeProfile.EmployeeProfileList, "userId");
          if (
            state.EmployeeProfile.EmployeeProfileList != undefined ||
            (state.EmployeeProfile.EmployeeProfileList != null &&
              state.EmployeeProfile.EmployeeProfileList.length > 0 &&
              state.EmployeeProfile.EmployeeProfileList.user_id != undefined &&
              state.EmployeeProfile.EmployeeProfileList.user_id.id != undefined)
          ) {
            const payload = {
              UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
              is_pending: SubRoleList == 0 ? true : false,
              is_decline: false, // is_decline: have to be true when the RM needs to approve
              create_employee: true,
              Decline: 0,
              payroll_approved:
                SubRoleList == 0 || SubRoleList == 3 ? true : true,
              send_whatsapp: sendOfferLetter, // Add the sendOfferLetter state to the payload

              // whatsapp_verify:  sendOfferLetter, // Add the sendOfferLetter state to the payload
              SubRoleList: SubRoleList,
              Ids: state.EmployeeProfile.EmployeeProfileList.user_id.id,
              date: state.NeededdatasListed.dateOfJoing,
            };
            console.log(payload, "27381972payload");

            if (!RMADMIN) {
              dispatch(SetApprovalCallsActions(payload));
            } else if (RMADMIN) {
              const payload = {
                UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
                is_pending: SubRoleList == 0 ? true : false,
                is_decline: false, // is_decline: have to be true when the RM needs to approve
                create_employee: true,
                Decline: 0,
                payroll_approved:
                  SubRoleList == 0 || SubRoleList == 3 ? true : true,
                send_whatsapp: sendOfferLetter, // Add the sendOfferLetter state to the payload
                SubRoleList: SubRoleList,
                Ids: state.EmployeeProfile.EmployeeProfileList.user_id.id,
                date: state.NeededdatasListed.dateOfJoing,
              };
              dispatch(SetTheJoiningDateCall(payload));
              //  navigate("/employeeprofile");
            }
            //  dispatch(SetTheJoiningDateCall(payload))

            // if (SubRoleList == 1 || SubRoleList == 3) {
            //   navigate("/verifystatus");
            // } else {
            //   navigate("/employeeVerifylist");
            // }
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.close();
        }
      });
    }
  };

  ////------------------Declines-------------------------
  const HandleDecline = () => {
    Swal.fire({
      title: "Do you want to Reject?",
      html: `
        <style>
          .custom-swal-input:focus {
            border-color: #86b7fe !important;
            outline: 0 !important;
            box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
          }
        </style>
        <div style="text-align: left; width: 90%; margin: auto;">
          <label style="font-weight: bold; display: block; margin-bottom: 5px; font-size: 15px; color: #333;">Rejection Type <span style="color: red;">*</span></label>
          <select id="swal-rejection-type" class="custom-swal-input" style="text-align: left; width: 100%; height: 45px; border: 1px solid #d9d9d9; border-radius: 5px; padding: 10px; font-size: 15px; color: #545454; background-color: #fff; box-shadow: inset 0 1px 1px rgba(0,0,0,0.06); margin: 0 0 15px 0; box-sizing: border-box; display: block;">
            <option value="" disabled selected>Select Rejection Type</option>
            <option value="0">Bank Details</option>
            <option value="1">Aadhar Card</option>
            <option value="2">PAN Card</option>
            <option value="3">Other Reasons</option>
          </select>
          <label style="font-weight: bold; display: block; margin-bottom: 5px; font-size: 15px; color: #333;">Remarks <span style="color: red;">*</span></label>
          <textarea id="swal-remarks" class="custom-swal-input" placeholder="Reason for reject..." style="text-align: left; width: 100%; border: 1px solid #d9d9d9; border-radius: 5px; padding: 10px; font-size: 15px; color: #545454; background-color: #fff; box-shadow: inset 0 1px 1px rgba(0,0,0,0.06); margin: 0; box-sizing: border-box; height: 100px; display: block; resize: vertical;"></textarea>
        </div>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",
      confirmButtonText: "Yes, Reject it!",
      focusConfirm: false,
      preConfirm: () => {
        const rejectionType = document.getElementById("swal-rejection-type").value;
        const remarks = document.getElementById("swal-remarks").value;
        if (!rejectionType) {
          Swal.showValidationMessage("You need to select a rejection type");
          return false;
        }
        if (!remarks) {
          Swal.showValidationMessage("You need to provide a reason/remarks for rejecting");
          return false;
        }
        return { rejection_type: rejectionType, remarks: remarks };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { rejection_type, remarks } = result.value;
        const payload = {
          formdatas: {
            remarks: remarks,
            user_id: state.EmployeeProfile.EmployeeProfileList.user_id.id,
            rejection_type: rejection_type,
          },
          API: 1,
          Funcations: () => {
            navigate("/approverequestemp");
          },
        };

        dispatch(gettheStoretheRejoiningActions(payload));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          text: " Employee verification as been cancel",
          icon: "error",
        });
        Swal.close();
      }
    });
  };

  //  console.log(state.ClientBranchIDs.SUBROLE , "SUBROLE");

  // const fetchPdf = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await fetch(
  //       pdfgetlistapi + state.ClientBranchIDs.EmployeeDetailsProfile + "/",
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     console.log(response, "response");
  //     if (!response.ok) {
  //       throw new Error("Network response was not ok");
  //     }
  //     const pdfBlob = await response.blob();
  //     const url = URL.createObjectURL(pdfBlob);
  //     setPdfUrl(url);
  //   } catch (error) {
  //     console.error("Error fetching PDF:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  console.log(
    state.NumberCounts.AllFormPDF,
    "asudpoasidoas dstate.NumberCounts.AllFormPDF",
  );

  useEffect(() => {
    if (
      state.ManPowerActiveDataTabs.statusCOdeForESign !== undefined &&
      state.ManPowerActiveDataTabs.statusCOdeForESign !== null &&
      state.ManPowerActiveDataTabs.statusCOdeForESign === 200 &&
      // &&
      // StatusCode
      result
    ) {
      if (PhonerNumber != undefined) {
        handleSwalFire(result);
      }
    }
  }, [state.ManPowerActiveDataTabs.statusCOdeForESign, result]);

  var PhoneNumberForOtp;
  //---have to check the signature with the phone number fileds-----------
  const HandleCreateEmployee = () => {
    const inputValue =
      state.EmployeeVerificationsNeed.OnborderPhoneNumber != undefined &&
        state.EmployeeVerificationsNeed.OnborderPhoneNumber != null
        ? state.EmployeeVerificationsNeed.OnborderPhoneNumber
        : "";

    Swal.fire({
      title: "Please enter your phone number",
      input: "number",
      inputPlaceholder: "Phone Number",
      inputAttributes: {
        min: 0,
        max: 10,
        disabled: true
      },
      allowOutsideClick: false,
      inputValue,
      // allowOutsideClick: true, // Allow closing the popup by clicking outside

      inputValidator: (value) => {
        if (!value) {
          return "Phone number is required";
        }
        if (value.length > 10) {
          return "Phone number cannot be longer than 10 digits";
        }
        if (value.length < 10) {
          return "Phone number cannot be Less than 10 digits";
        }
      },
      showCancelButton: true,
      confirmButtonText: "Submit",
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",

      inputClass: "custom-inputField", // Add a custom

      preConfirm: (phone) => {
        // Here you can handle the submission of the phone number
        PhoneNumberForOtp = phone;
        console.log(PhoneNumberForOtp, "PhoneNumberForOtp");
        const payload = {
          phone_number: phone,
        };

        setPhoneNumber(phone);

        //console.log("PhoneNum6876687ber:", phone, PhonerNumber);
        dispatch(setTheActionForOtpPhoneNumbers(payload)); ///--- for the  --phone number

        return new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, 2000); // Simulating server request delay
        });
      },
      // allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      setResult(result); // Set 'result' state here
      if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          text: "Employee verification has been cancelled",
          icon: "error",
        });
        dispatch(setTheEsignatureCodes(502)); //for close the otp

        Swal.close();
      }
    });
  };

  function handleSwalFire(result) {
    if (result) {
      const timerDuration = 60;
      let timeLeft = timerDuration;
      function formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const secondsRemaining = seconds % 60;
        return `${minutes}:${secondsRemaining < 10 ? "0" : ""}${secondsRemaining}`;
      }
      Swal.fire({
        title: "Please enter the OTP sent to your phone",
        html: `
<div id="otp-container" style="display: flex; flex-direction: column; gap: 10px;">
  <div id="timer">Time remaining: <span id="timer-count">${formatTime(timeLeft)}</span></div>
  <div style="display: flex; gap: 10px;">
    <input type="text" maxlength="1" size="1" class="swal2-input" id="otp1">
    <input type="text" maxlength="1" size="1" class="swal2-input" id="otp2">
    <input type="text" maxlength="1" size="1" class="swal2-input" id="otp3">
    <input type="text" maxlength="1" size="1" class="swal2-input" id="otp4">
    <input type="text" maxlength="1" size="1" class="swal2-input" id="otp5">
    <input type="text" maxlength="1" size="1" class="swal2-input" id="otp6">
  </div>
</div>

        <button id="resend-otp" style="display:none;padding:10px;border-radius:4px;background:rgb(246, 147, 56);color:white">Resend OTP</button>
      `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Verify",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        confirmButtonColor: "#f26639",
        cancelButtonColor: "#F69338",
        didOpen: () => {
          const inputs = document.querySelectorAll(".swal2-input");
          const timerCountElement = document.getElementById("timer-count");
          const resendButton = document.getElementById("resend-otp");
          const verifyButton = Swal.getConfirmButton();
          verifyButton.disabled = true; // Disable the button initially

          inputs.forEach((input, index) => {
            input.dataset.index = index;
            input.addEventListener("keyup", handleOtp);
            input.addEventListener("input", handleNumericInput);

            input.addEventListener("paste", handleOnPasteOtp);
          });
          document
            .getElementById("resend-otp")
            .addEventListener("click", handleResendOtp);

          function handleOtp(e) {
            const input = e.target;
            let value = input.value;
            let isValidInput = value.match(/[0-9a-z]/gi);
            input.value = isValidInput ? value[0] : "";
            let fieldIndex = input.dataset.index;

            if (fieldIndex < inputs.length - 2 && isValidInput) {
              input.nextElementSibling.focus();
            }
            if (e.key === "Backspace" && fieldIndex > 0) {
              input.previousElementSibling.focus();
            }
            if (fieldIndex == inputs.length - 2 && isValidInput) {
              submit();
            }
          }

          function handleNumericInput(e) {
            e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove any non-numeric characters
          }

          function handleOnPasteOtp(e) {
            const data = e.clipboardData.getData("text");
            const value = data.split("");
            if (value.length === inputs.length) {
              inputs.forEach((input, index) => (input.value = value[index]));
              submit();
            }
          }

          function submit() {
            let otp = "";
            inputs.forEach((input) => {
              otp += input.value;
            });

            // Define and dispatch the action
            const payload = {
              otp: {
                phone_number: PhonerNumber,
                otp: otp,
              },
              Funcations: () => {
                // Your function logic here
                Swal.close();
              },
            };
            dispatch(setTheActionForOtpwithPhoneNumbers(payload));
          }

          function updateTimer() {
            timeLeft--;
            timerCountElement.textContent = formatTime(timeLeft);
            if (timeLeft <= 0) {
              clearInterval(timerInterval);
              // Optionally disable inputs and show resend button
              // inputs.forEach(input => input.disabled = true);
              resendButton.style.display = "inline-block";
              resendButton.addEventListener("click", handleResendOtp);
            }
          }

          let timerInterval = setInterval(updateTimer, 1000);

          function handleResendOtp() {
            // Implement OTP resend logic here
            // console.log('Resend OTP logic here');
            // You may also want to reset the timer here
            const payload = {
              phone_number: PhonerNumber,
            };

            //console.log("PhoneNum6876687ber:", phone, PhonerNumber);
            dispatch(setTheActionResentForOtpPhoneNumbers(payload)); ///--- for the  --phone number

            // // Clear the input values
            // inputs.forEach((input) => {
            //   input.value = "";
            //   input.disabled = false; // Ensure inputs are enabled
            //   input.classList.remove("disabled"); // Remove disabled class if any
            // });

            // // Reset the timer if needed
            // timeLeft = 50; // Example of resetting the timer to 5 minutes
            // document.getElementById("timer-count").textContent = formatTime(timeLeft);

            // Clear the input values
            inputs.forEach((input) => {
              input.value = "";
              input.disabled = false; // Ensure inputs are enabled
              input.classList.remove("disabled"); // Remove disabled class if any
            });

            // Clear existing timer interval
            if (timerInterval) {
              clearInterval(timerInterval);
            }

            // Reset the timer
            timeLeft = 60; // Reset timer to 10 seconds or your preferred value
            const timerElement = document.getElementById("timer-count");

            if (timerElement) {
              timerElement.textContent = formatTime(timeLeft);
              //  console.log(timerElement , "938wudjtimerElement");
            } else {
              console.error("Timer element not found");
            }

            // Start the timer again
            timerInterval = setInterval(() => {
              if (timeLeft <= 0) {
                clearInterval(timerInterval);
                console.log("OTP timer expired");
              } else {
                timeLeft -= 1;
                if (timerElement) {
                  timerElement.textContent = formatTime(timeLeft);
                  console.log(
                    timerElement.textContent,
                    "timerElement",
                    timerElement.textContent == "0:00",
                  );
                  if (timerElement.textContent == "0:00") {
                    resendButton.style.display = "inline-block";
                  }
                } else {
                  console.error("Timer element not found");
                }
              }
            }, 1000);

            resendButton.style.display = "none";
          }
        },
      });
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      dispatch(setTheEsignatureCodes(502)); //for close the otp
      Swal.fire({
        text: "Employee verification has been cancelled",
        icon: "error",
      });

      Swal.close();
    }
  }

  useEffect(() => {
    dispatch(setTheSignaturePadNumberSet(0));
  }, []);

  useEffect(() => {
    if (
      state.NumberCounts.Editable == 1 &&
      state.ClientBranchIDs.ApproveRequest == 2
    ) {
      dispatch(getSideBarfilesActions("Approve Request"));
    }
    if (
      state.NumberCounts.Editable == 2 &&
      state.ClientBranchIDs.ApproveRequest == 4
    ) {
      dispatch(getSideBarfilesActions("Onboarding"));
    }
    if (
      state.NumberCounts.Editable == 2 &&
      state.ClientBranchIDs.ApproveRequest == 5
    ) {
      dispatch(getSideBarfilesActions("My Onboarding List"));
    }

    if (
      // state.NumberCounts.Editable == 2 &&
      state.ClientBranchIDs.ApproveRequest == 3
    ) {
      dispatch(getSideBarfilesActions("Client"));
    }

    if (
      state.NumberCounts.Editable == 1 &&
      state.ClientBranchIDs.ApproveRequest == 6
    ) {
      dispatch(getSideBarfilesActions("Overview"));
    }

    if (
      state.NumberCounts.Editable == 1 &&
      state.ClientBranchIDs.ApproveRequest == 7
    ) {
      dispatch(getSideBarfilesActions("Onboard Overview"));
    }
  }, [
    state.NumberCounts.Editable,
    state.SideBarFiles.SideBarFile,
    state.ClientBranchIDs.ApproveRequest,
  ]);

  const HandletheRegeneratePdf = () => {
    Swal.fire({
      title: "Do you want to regenerate the pdf ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",
      confirmButtonText: "Regenerate it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          id: state.ClientBranchIDs.EmployeeDetailsProfile,
          overwritedatas: {
            overwrite: true,
          },
        };

        dispatch(gettheRegeneratePdfAction(payload));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };
  const employeeData = state.EmployeeProfile.EmployeeProfileList
  const isDenaveAllFormTrue = employeeData?.is_basic_info && employeeData?.is_address_details && employeeData?.is_bank_details && employeeData?.is_declaration_form && employeeData?.is_education_details && employeeData?.is_previous_employee && employeeData?.is_esi_form && employeeData?.is_job_description
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Employee Profile </h3>
          </div>
        </div>

        <br />

        <div
          className="row Filters ButtonPrevious"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",

            marginLeft: "0px",
            marginRight: "0px",
            top: "-46px",
          }}
        >
          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                navigate(
                  state.NumberCounts.Editable != 2
                    ? state.SideBarFiles.SideBarFile == "Approve Request"
                      ? "/approverequestemp"
                      : state.SideBarFiles.SideBarFile == "Overview"
                        ? // ? "/"
                        "/employeeVerifylist"
                        : state.SideBarFiles.SideBarFile == "Onboard Overview"
                          ? "/employeeVerifylist"
                          : // "/onboardDashboard"
                          state.SideBarFiles.SideBarFile == "Client" &&
                          "/clientDetails"
                    : state.SideBarFiles.SideBarFile == "My Onboarding List"
                      ? "/myonboarding"
                      : "/fieldagent",
                );
              }}
            >
              <img className="PreviousPages" src={BackImage} />
              <span></span>
            </button>
          </div>
          <div
            className="col"
            style={{ display: "flex", justifyContent: "flex-end", gap: "30px" }}
          >
            {/* ----Kyc Reject---- */}
            {state.SideBarFiles.SideBarFile == "Approve Request" ||
              ((state.SideBarFiles.SideBarFile == "Overview" ||
                state.SideBarFiles.SideBarFile == "Onboard Overview") &&
                RejectionDisplay == true &&
                (state.ClientBranchIDs.SUBROLE == 3 ||
                  state.ClientBranchIDs.SUBROLE == 0 ||
                  state.ClientBranchIDs.SUBROLE == 1) &&
                RejectionDisplay == true) ? (
              <button
                style={{
                  width: "115px",
                  height: "37px",
                  borderRadius: "4px",
                  letterSpacing: "1.2px",
                }}
                className="btn Preview"
                onClick={(e) => {
                  navigate("/reject");
                }}
              >
                Rejection
              </button>
            ) : null}
            {/* -----Rejoin---- */}
            {state.SideBarFiles.SideBarFile == "Approve Request" ||
              ((state.SideBarFiles.SideBarFile == "Overview" ||
                state.SideBarFiles.SideBarFile == "Onboard Overview") &&
                BasicForm == true && //RejoinBool
                (state.ClientBranchIDs.SUBROLE == 3 ||
                  state.ClientBranchIDs.SUBROLE == 0 ||
                  state.ClientBranchIDs.SUBROLE == 1)) ? (
              <button
                style={{
                  width: "115px",
                  height: "37px",
                  borderRadius: "4px",
                  letterSpacing: "1.2px",
                }}
                onClick={(e) => {
                  navigate("/rejoin");
                }}
                className="btn Preview"
              >
                Rejoining
              </button>
            ) : null}

            {
              // state.ClientBranchIDs.SUBROLE != null && state.ClientBranchIDs.SUBROLE != undefined && state.ClientBranchIDs.SUBROLE == 3

              // &&
              // state.NumberCounts.Editable == 1 &&
              // state.ClientBranchIDs.EmployeeDetailsProfile != "" &&
              // state.SideBarFiles.SideBarFile == "Approve Request" ||
              // ( state.SideBarFiles.SideBarFile == "Overview" || state.SideBarFiles.SideBarFile == "Onboard Overview")

              // &&
              // state.NumberCounts.AllFormPDF

              state.ClientBranchIDs.SUBROLE != null &&
                state.ClientBranchIDs.SUBROLE != undefined &&
                state.ClientBranchIDs.SUBROLE == 3 &&
                state.NumberCounts.Editable == 1 &&
                state.ClientBranchIDs.EmployeeDetailsProfile != "" &&
                state.NumberCounts.AllFormPDF &&
                state.EmployeeProfile.EmployeeProfileList.create_employee ===
                true &&
                state.ClientBranchIDs.SUBROLE !== 2 &&
                // state.pdfdownloadcall.PdfDownloadDatas &&
                // state.pdfdownloadcall.PdfDownloadDatas !== undefined &&
                // state.pdfdownloadcall.PdfDownloadDatas !== "" &&
                // state.pdfdownloadcall.PdfDownloadDatas !== null &&
                //             state.pdfdownloadcall.PdfDownloadDatas != [] &&

                // Array.isArray(state.pdfdownloadcall.PdfDownloadDatas) &&
                // state.pdfdownloadcall.PdfDownloadDatas.length > 0 &&
                (state.SideBarFiles.SideBarFile === "Approve Request" ||
                  state.SideBarFiles.SideBarFile === "Overview" ||
                  state.SideBarFiles.SideBarFile === "Onboard Overview") ? (
                <button
                  style={{
                    width: "124px",
                    height: "37px",
                    borderRadius: "4px",
                    letterSpacing: "1.2px",
                  }}
                  onClick={(e) => {
                    HandletheRegeneratePdf();
                  }}
                  className="btn Preview"
                >
                  Regenerate
                </button>
              ) : null
            }

            {/* <PDFViewer> */}
            {
              //           state.EmployeeProfile.EmployeeProfileList.create_employee === true &&

              //                     state.ClientBranchIDs.SUBROLE != 2 &&

              //         state.pdfdownloadcall.PdfDownloadDatas &&
              //         state.pdfdownloadcall.PdfDownloadDatas != undefined &&
              //         state.pdfdownloadcall.PdfDownloadDatas != "" &&
              //         state.pdfdownloadcall.PdfDownloadDatas != null &&
              //         state.pdfdownloadcall.PdfDownloadDatas != []
              //   &&
              //   // state.SideBarFiles.SideBarFile =="My Onboarding List" ||

              //   state.SideBarFiles.SideBarFile == "Approve Request" ||

              //  ( state.SideBarFiles.SideBarFile == "Overview" || state.SideBarFiles.SideBarFile == "Onboard Overview")

              state.EmployeeProfile.EmployeeProfileList.create_employee ===
                true &&
                state.ClientBranchIDs.SUBROLE !== 2 &&
                // state.pdfdownloadcall.PdfDownloadDatas &&
                // state.pdfdownloadcall.PdfDownloadDatas !== undefined &&
                // state.pdfdownloadcall.PdfDownloadDatas !== "" &&
                // state.pdfdownloadcall.PdfDownloadDatas !== null &&
                //             state.pdfdownloadcall.PdfDownloadDatas != [] &&

                // Array.isArray(state.pdfdownloadcall.PdfDownloadDatas) &&
                // state.pdfdownloadcall.PdfDownloadDatas.length > 0 &&

                (state.SideBarFiles.SideBarFile === "Approve Request" ||
                  state.SideBarFiles.SideBarFile === "Overview" ||
                  state.SideBarFiles.SideBarFile === "Onboard Overview") && (organization?.organization?.id ==
                    "11a8ab83-0669-4098-a453-ddb2a2e0c39e" ? isDenaveAllFormTrue ? true : false : true) ? (
                <button
                  style={{
                    width: "115px",
                    height: "37px",
                    borderRadius: "4px",
                    letterSpacing: "1.2px",
                  }}
                  onClick={(e) => {
                    if (state.NumberCounts.AllFormPDF) {
                      setopen(!open);
                    } else {
                      toast.error(
                        ` ${"The form creation was unsuccessful, so the preview is not visible."} `,
                        {
                          position: toast.POSITION.TOP_RIGHT,
                        },
                      );
                    }
                  }}
                  className="btn Preview"
                >
                  Preview
                </button>
              ) : null
            }
          </div>
        </div>

        <div className="Header-Details EmployeeProfileHeaders">
          <div className="InnerDetails">
            <div className="InnerDetailPart">
              <div className="LOGO">
                {UserImage != null ? (
                  <img src={UserImage} />
                ) : (
                  <img src={profile2} />
                )}
              </div>
              <p className="EMpCODER">
                <span>{UserName}</span>
                <span>
                  <>
                    {" "}
                    Emp Code :{" "}
                    <span>{RoleName != "" ? <>{RoleName}</> : <>--</>}</span>
                  </>
                </span>
              </p>
            </div>

            <div className="ROLE">
              <div className="LOGO EMCANDACTIVE">
                {EmpActive == true && RoleName != "" ? (
                  <>
                    <span>Active</span>
                    <span className="ActiveImage">
                      <img src={ActiveEmc} />
                    </span>
                  </>
                ) : EmpActive == false && RoleName != "" ? (
                  <>
                    <span>Inactive</span>
                    <span className="ActiveImage">
                      <img src={InActiveEmc} />
                    </span>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <div className="row EmpPorfile">
          {/* -------------------------------Forms---------------------------------- */}

          {/* -------------------__Basic----Forms---------------------------------------- */}

          {/* {state.EmployeeProfile.EmployeeProfileList != undefined && */}
          {/* state.EmployeeProfile.EmployeeProfileList.basic_info != undefined && */}
          {/* state.EmployeeProfile.EmployeeProfileList.basic_info.id != */}
          {/* undefined ? ( */}
          <>
            {/* {state.EmployeeProfile.EmployeeProfileList.map((item) => ( */}
            <div
              className="col-md-3 Cards"
              id="ex3-tab-1"
              onClick={(e) => {
                if (
                  state.EmployeeProfile.EmployeeProfileList.basic_info !=
                  null &&
                  state.EmployeeProfile.EmployeeProfileList.basic_info !=
                  undefined &&
                  state.NumberCounts.Editable != 2
                ) {
                  navigate("/formtab");
                  //BasicFormId(item.basic_info.id  )
                  dispatch(
                    SetBasiformsID(
                      state.EmployeeProfile.EmployeeProfileList.basic_info.id,
                    ),
                  );
                } ///---to--make ---as readonly
                else if (
                  state.NumberCounts.Editable == 2 &&
                  state.EmployeeProfile.EmployeeProfileList == "" &&
                  state.EmployeeProfile.EmployeeProfileList.basic_info == null
                ) {
                  dispatch(SetBasiformsID(""));
                  if (
                    state.FormsIDList.BasicFormID == "" &&
                    state.EmployeeProfile.EmployeeProfileList.basic_info == null
                  ) {
                    navigate("/formtab");
                  }
                } ///---fro--create-----
                else if (
                  state.NumberCounts.Editable == 2 &&
                  state.EmployeeProfile.EmployeeProfileList != "" &&
                  state.EmployeeProfile.EmployeeProfileList.basic_info !=
                  null &&
                  state.EmployeeProfile.EmployeeProfileList.basic_info !=
                  undefined
                ) {
                  //---for---edit-----
                  dispatch(
                    SetBasiformsID(
                      state.EmployeeProfile.EmployeeProfileList.basic_info.id,
                    ),
                  );
                  navigate("/formtab");
                } else {
                  toast.error(` ${" Basic Information  form is not filled"} `, {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                }

                dispatch(SetActiveTabs(1));
              }}
            // console.log(e, "basic Ids", item.basic_info.id);

            //  dispatch(SetAddressId(item.address_details.id))
            // if (state.FormsIDList.BasicFormID == item.basic_info.id && state.FormsIDList.AddressId  == item.address_details.id) {
            // navigate("/basicform");
            //
            // }
            // }}
            >
              <div className="card">
                <div className="card-body EmployeeCardBody">
                  <div className="WIthPendingStatus">
                    <h5>Basic Information</h5>

                    <div className="ICONS">
                      <img
                        src={
                          BasicForm
                            ? correctIcons
                            : state.EmployeeProfile.EmployeeProfileList == ""
                              ? emptycircle
                              : Pending
                        }
                      />
                      <img src={ArrowIcons} />
                    </div>
                  </div>

                  <p>Personal information & Other Details</p>
                </div>
              </div>
            </div>
          </>
          {/* // ) : null} */}

          {/* -----------------------Address----Details---------------------------------- */}
          {/* {state.EmployeeProfile.EmployeeProfileList != undefined && */}
          {/* //  state.EmployeeProfile.EmployeeProfileList.address_details !=
              // undefined  ? (  */}
          <>
            {/* {state.EmployeeProfile.EmployeeProfileList.map((item) => ( */}
            <div
              className="col-md-3 tab-pane  Cards"
              id="ex3-tabs-2"
              disabled={
                state.EmployeeProfile.EmployeeProfileList.address_details ==
                null &&
                state.EmployeeProfile.EmployeeProfileList.address_details ==
                undefined
              }
              // onClick={(e) => {
              // navigate("/formtab");
              // dispatch(
              // SetAddressId(
              // state.EmployeeProfile.EmployeeProfileList.address_details
              // .id
              // )
              // );
              // dispatch(SetActiveTabs(2))
              // }}

              onClick={(e) => {
                // console.log(
                //   state.EmployeeProfile.EmployeeProfileList.address_details,
                //   "szczx detailss"
                // );
                if (
                  state.EmployeeProfile.EmployeeProfileList.address_details !=
                  null &&
                  state.EmployeeProfile.EmployeeProfileList.address_details !=
                  undefined &&
                  state.NumberCounts.Editable != 2
                ) {
                  dispatch(
                    SetAddressId(
                      state.EmployeeProfile.EmployeeProfileList.address_details
                        .id,
                    ),
                  );
                  navigate("/formtab");
                } else if (
                  state.NumberCounts.Editable == 2 &&
                  state.EmployeeProfile.EmployeeProfileList.address_details !=
                  null &&
                  state.EmployeeProfile.EmployeeProfileList.address_details !=
                  undefined
                ) {
                  dispatch(
                    SetAddressId(
                      state.EmployeeProfile.EmployeeProfileList.address_details
                        .id,
                    ),
                  );

                  navigate("/formtab");
                } else if (
                  state.NumberCounts.Editable == 2 &&
                  state.EmployeeProfile.EmployeeProfileList.address_details ==
                  null &&
                  state.EmployeeProfile.EmployeeProfileList.address_details ==
                  undefined &&
                  state.EmployeeProfile.EmployeeProfileList.basic_info !=
                  null &&
                  state.EmployeeProfile.EmployeeProfileList.basic_info !=
                  undefined
                ) {
                  dispatch(SetAddressId(""));
                  if (
                    // state.EmployeeProfile.EmployeeProfileList.address_details ==
                    //   null &&
                    state.FormsIDList.AddressId == ""
                  ) {
                    navigate("/formtab");
                  }
                } else if (state.NumberCounts.Editable == 2) {
                  toast.error(
                    ` ${"The Address Details form can only be filled after the Basic Information is completed"} `,
                    {
                      position: toast.POSITION.TOP_RIGHT,
                    },
                  );
                } else if (state.NumberCounts.Editable == 1) {
                  toast.error(` ${"Address Details form is not filled"} `, {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                }
                dispatch(SetActiveTabs(2));
              }}
            >
              <div className="card">
                <div className="card-body EmployeeCardBody">
                  <div className="WIthPendingStatus">
                    <h5>Address Details </h5>

                    <div className="ICONS">
                      <img
                        src={
                          AdderDeatils
                            ? correctIcons
                            : state.EmployeeProfile.EmployeeProfileList == ""
                              ? ""
                              : Pending
                        }
                      />
                      <img src={ArrowIcons} />
                    </div>
                  </div>

                  <p>Current & Permanent Address Details</p>
                </div>
              </div>
            </div>
          </>
          {/* ) : null}  */}

          {/* ------------------__JOB-------OFFERS----------------------------------- */}
          <div
            className="col-md-3 Cards"
            disabled={
              state.EmployeeProfile.EmployeeProfileList == null &&
              state.EmployeeProfile.EmployeeProfileList == ""
            }
            onClick={(e) => {
              if (
                state.EmployeeProfile.EmployeeProfileList.job_description !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.job_description !=
                undefined &&
                state.NumberCounts.Editable != 2
              ) {
                dispatch(
                  SetJobOfferID(
                    state.EmployeeProfile.EmployeeProfileList.job_description
                      .id,
                  ),
                );

                navigate("/formtab");
              } ///---for---readonly
              else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList.job_description !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.job_description !=
                undefined
              ) {
                dispatch(
                  SetJobOfferID(
                    state.EmployeeProfile.EmployeeProfileList.job_description
                      .id,
                  ),
                );
                navigate("/formtab");
              } ///-----edit or view
              else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList.job_description ==
                null &&
                state.EmployeeProfile.EmployeeProfileList.job_description ==
                undefined &&
                state.EmployeeProfile.EmployeeProfileList.address_details !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.address_details !=
                undefined
                //state.EmployeeProfile.EmployeeProfileList != "" &&
                // state.EmployeeProfile.EmployeeProfileList.job_description ==
                //   null
              ) {
                dispatch(SetJobOfferID(""));
                if (state.FormsIDList.Job_offer_id == "") {
                  navigate("/formtab");
                }
              }
              //--edit
              // else if (
              //   state.NumberCounts.Editable == 2 &&
              //   state.EmployeeProfile.EmployeeProfileList == ""
              // ) {
              //   dispatch(SetJobOfferID(""));

              //   if (state.FormsIDList.Job_offer_id == "") {
              //     navigate("/formtab");
              //   }
              // } ///create
              else if (state.NumberCounts.Editable == 2) {
                toast.error(
                  ` ${"The Job Information form can only be filled after the Address Details is completed"} `,
                  {
                    position: toast.POSITION.TOP_RIGHT,
                  },
                );
              } else if (state.NumberCounts.Editable == 1) {
                toast.error(` ${"Job Offer Detail form is not filled"} `, {
                  position: toast.POSITION.TOP_RIGHT,
                });
              }

              dispatch(SetActiveTabs(10));
            }}
          >
            <div className="card">
              <div className="card-body EmployeeCardBody">
                <div className="WIthPendingStatus">
                  <h5>Job Information</h5>
                  <div className="ICONS">
                    <img
                      src={
                        JobOffer
                          ? correctIcons
                          : state.EmployeeProfile.EmployeeProfileList == ""
                            ? ""
                            : Pending
                      }
                    />
                    <img src={ArrowIcons} />
                  </div>
                </div>
                <p>Enter Your Job Information Details </p>
              </div>
            </div>
          </div>

          {/* --------------------------ID---VERIFICATIONS============================= */}
          <div
            className="col-md-3 Cards"
            disabled={
              state.EmployeeProfile.EmployeeProfileList.id_verification == null
            }
            onClick={(e) => {
              if (
                state.EmployeeProfile.EmployeeProfileList != undefined &&
                state.EmployeeProfile.EmployeeProfileList != null &&
                state.EmployeeProfile.EmployeeProfileList.id_verification !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.id_verification !=
                undefined &&
                state.EmployeeProfile.EmployeeProfileList.id != undefined &&
                state.EmployeeProfile.EmployeeProfileList.id_verification.id !=
                undefined &&
                state.NumberCounts.Editable != 2
              ) {
                if (
                  state.EmployeeProfile.EmployeeProfileList.basic_info !=
                  null &&
                  state.EmployeeProfile.EmployeeProfileList.basic_info !=
                  undefined
                ) {
                  dispatch(
                    SetBasiformsID(
                      state.EmployeeProfile.EmployeeProfileList.basic_info.id,
                    ),
                  );
                }

                if (
                  state.EmployeeProfile.EmployeeProfileList.address_details !=
                  null &&
                  state.EmployeeProfile.EmployeeProfileList.address_details !=
                  undefined
                ) {
                  dispatch(
                    SetAddressId(
                      state.EmployeeProfile.EmployeeProfileList.address_details
                        .id,
                    ),
                  );
                }

                dispatch(
                  SetIdVeriications(
                    state.EmployeeProfile.EmployeeProfileList.id_verification
                      .id,
                  ),
                );
                navigate("/formtab");
              } else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList != null &&
                state.EmployeeProfile.EmployeeProfileList.id_verification !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.id_verification !=
                undefined &&
                state.EmployeeProfile.EmployeeProfileList.id != undefined &&
                state.EmployeeProfile.EmployeeProfileList.id_verification.id !=
                undefined
              ) {
                if (
                  state.EmployeeProfile.EmployeeProfileList.basic_info !=
                  null &&
                  state.EmployeeProfile.EmployeeProfileList.basic_info !=
                  undefined
                ) {
                  dispatch(
                    SetBasiformsID(
                      state.EmployeeProfile.EmployeeProfileList.basic_info.id,
                    ),
                  );
                }

                if (
                  state.EmployeeProfile.EmployeeProfileList.address_details !=
                  null &&
                  state.EmployeeProfile.EmployeeProfileList.address_details !=
                  undefined
                ) {
                  dispatch(
                    SetAddressId(
                      state.EmployeeProfile.EmployeeProfileList.address_details
                        .id,
                    ),
                  );
                }

                dispatch(
                  SetIdVeriications(
                    state.EmployeeProfile.EmployeeProfileList.id_verification
                      .id,
                  ),
                );
                navigate("/formtab");
              } else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList.id_verification ==
                null &&
                state.EmployeeProfile.EmployeeProfileList.id_verification ==
                undefined &&
                state.EmployeeProfile.EmployeeProfileList.job_description !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.job_description !=
                undefined
                // state.EmployeeProfile.EmployeeProfileList != "" &&
                // state.EmployeeProfile.EmployeeProfileList.id_verification ==
                //   null
              ) {
                dispatch(SetIdVeriications(""));
                if (
                  // state.EmployeeProfile.EmployeeProfileList.id_verification ==
                  //   null &&
                  state.FormsIDList.Idverify == ""
                ) {
                  navigate("/formtab");
                }
              }
              // else if (
              //   state.NumberCounts.Editable == 2 &&
              //   state.EmployeeProfile.EmployeeProfileList == ""
              // ) {
              //   if (state.FormsIDList.Idverify == "") {
              //     navigate("/formtab");
              //   }
              // }
              else if (state.NumberCounts.Editable == 2) {
                toast.error(
                  ` ${"The ID Verification Details form can only be filled after the Job Information is completed"} `,
                  {
                    position: toast.POSITION.TOP_RIGHT,
                  },
                );
              } else if (state.NumberCounts.Editable == 1) {
                toast.error(
                  ` ${"ID Verification Details  form is not filled "} `,
                  {
                    position: toast.POSITION.TOP_RIGHT,
                  },
                );
              }
              dispatch(SetActiveTabs(3));
            }}
          >
            <div className="card">
              <div className="card-body EmployeeCardBody">
                <div className="WIthPendingStatus">
                  <h5>ID Verification Details</h5>
                  <div className="ICONS">
                    <img
                      src={
                        Verify ||
                          (state.EmployeeProfile.EmployeeProfileList != "" &&
                            state.NumberCounts.Editable == 2)
                          ? correctIcons
                          : state.EmployeeProfile.EmployeeProfileList == ""
                            ? ""
                            : Pending
                      }
                    />
                    <img src={ArrowIcons} />
                  </div>
                </div>
                <p>Aadhaar and PAN Details</p>
              </div>
            </div>
          </div>

          {/* ------------------BANK----------Details--------------------------------- */}
          <div
            className="col-md-3 Cards"
            disabled={
              state.EmployeeProfile.EmployeeProfileList.bank_details == null
            }
            onClick={(e) => {
              if (
                state.EmployeeProfile.EmployeeProfileList != undefined &&
                state.EmployeeProfile.EmployeeProfileList != null &&
                state.EmployeeProfile.EmployeeProfileList.bank_details !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.bank_details !=
                undefined &&
                state.EmployeeProfile.EmployeeProfileList.id != undefined &&
                state.EmployeeProfile.EmployeeProfileList.bank_details.id !=
                undefined &&
                state.NumberCounts.Editable != 2
              ) {
                dispatch(
                  setBankDetailsId(
                    state.EmployeeProfile.EmployeeProfileList.bank_details.id,
                  ),
                );
                navigate("/formtab");
              } else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList != null &&
                state.EmployeeProfile.EmployeeProfileList.bank_details !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.bank_details !=
                undefined &&
                state.EmployeeProfile.EmployeeProfileList.id != undefined &&
                state.EmployeeProfile.EmployeeProfileList.bank_details.id !=
                undefined
              ) {
                dispatch(
                  setBankDetailsId(
                    state.EmployeeProfile.EmployeeProfileList.bank_details.id,
                  ),
                );
                navigate("/formtab");
              } else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList.bank_details ==
                null &&
                state.EmployeeProfile.EmployeeProfileList.bank_details ==
                undefined &&
                state.EmployeeProfile.EmployeeProfileList.id_verification !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.id_verification !=
                undefined &&
                state.EmployeeProfile.EmployeeProfileList.job_description !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.job_description !=
                undefined

                //state.EmployeeProfile.EmployeeProfileList.bank_details == null
              ) {
                dispatch(setBankDetailsId(""));
                if (
                  state.FormsIDList.BankDetailID == ""

                  // state.EmployeeProfile.EmployeeProfileList.bank_details == null
                ) {
                  navigate("/formtab");
                }
              } else if (state.NumberCounts.Editable == 2) {
                toast.error(
                  ` ${"The Bank Details form can only be filled after the ID Verification Details  is completed"} `,
                  {
                    position: toast.POSITION.TOP_RIGHT,
                  },
                );
              } else if (state.NumberCounts.Editable == 1) {
                toast.error(` ${"Bank Details form is not filled "} `, {
                  position: toast.POSITION.TOP_RIGHT,
                });
              }
              dispatch(SetActiveTabs(4));
            }}
          >
            <div className="card">
              <div className="card-body EmployeeCardBody">
                <div className="WIthPendingStatus">
                  <h5>Bank Details</h5>
                  <div className="ICONS">
                    <img
                      src={
                        BankDetail
                          ? correctIcons
                          : state.EmployeeProfile.EmployeeProfileList == ""
                            ? ""
                            : Pending
                      }
                    />
                    <img src={ArrowIcons} />
                  </div>
                </div>
                <p>Account Number and IFSC Code Details</p>
              </div>
            </div>
          </div>

          {/*  */}
          {/* ---------------------_EDUCATION----DETAILS------------------------------------ */}

          <div
            className="col-md-3 Cards"
            disabled={
              state.EmployeeProfile.EmployeeProfileList.education_details ==
              null
            }
            onClick={(e) => {
              if (
                state.EmployeeProfile.EmployeeProfileList != undefined &&
                state.EmployeeProfile.EmployeeProfileList != null &&
                state.EmployeeProfile.EmployeeProfileList.education_details !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.education_details !=
                undefined &&
                state.EmployeeProfile.EmployeeProfileList.id != undefined &&
                state.EmployeeProfile.EmployeeProfileList.education_details
                  .id != undefined &&
                state.NumberCounts.Editable != 2
              ) {
                dispatch(
                  SetEducationDetails(
                    state.EmployeeProfile.EmployeeProfileList.education_details
                      .id,
                  ),
                );
                navigate("/formtab");
              } else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList != null &&
                state.EmployeeProfile.EmployeeProfileList.education_details !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.education_details !=
                undefined &&
                state.EmployeeProfile.EmployeeProfileList.id != undefined &&
                state.EmployeeProfile.EmployeeProfileList.education_details
                  .id != undefined
              ) {
                dispatch(
                  SetEducationDetails(
                    state.EmployeeProfile.EmployeeProfileList.education_details
                      .id,
                  ),
                );
                navigate("/formtab");
              } else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList.education_details ==
                null &&
                state.EmployeeProfile.EmployeeProfileList.education_details ==
                "" &&
                state.EmployeeProfile.EmployeeProfileList.bank_details !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.bank_details !=
                undefined

                // state.EmployeeProfile.EmployeeProfileList.education_details ==
                //   null
              ) {
                dispatch(SetEducationDetails(""));
                console.log(
                  state.NumberCounts.Editable,
                  state.FormsIDList.EducationID,
                  "EducationIDS",
                  state.FormsIDList.EducationID == "",
                  2,
                );

                if (state.FormsIDList.EducationID == "") {
                  navigate("/formtab");
                }
              } else if (state.NumberCounts.Editable == 2) {
                toast.error(
                  ` ${"The Education form can only be filled after the Bank Details form is completed"} `,
                  {
                    position: toast.POSITION.TOP_RIGHT,
                  },
                );
              } else if (state.NumberCounts.Editable == 1) {
                toast.error(` ${"Education details form is not filled"} `, {
                  position: toast.POSITION.TOP_RIGHT,
                });
              }
              dispatch(SetActiveTabs(5));
            }}
          >
            <div className="card">
              <div className="card-body EmployeeCardBody">
                <div className="WIthPendingStatus">
                  <h5>Education Details</h5>
                  <div className="ICONS">
                    <img
                      src={
                        Education
                          ? correctIcons
                          : state.EmployeeProfile.EmployeeProfileList == ""
                            ? ""
                            : Pending
                      }
                    />
                    <img src={ArrowIcons} />
                  </div>
                </div>
                <p>Employee Education and Qualifications Details</p>
              </div>
            </div>
          </div>
          {/* --------------------------Previous---Employee----Details------------------------------ */}
          <div
            className="col-md-3 Cards"
            disabled={
              state.EmployeeProfile.EmployeeProfileList.employee_previous ==
              null
            }
            onClick={(e) => {
              if (
                state.EmployeeProfile.EmployeeProfileList.employee_previous !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.employee_previous !=
                undefined &&
                state.NumberCounts.Editable != 2
              ) {
                dispatch(
                  SetPreviousEmployeeID(
                    state.EmployeeProfile.EmployeeProfileList.employee_previous
                      .id,
                  ),
                );
                navigate("/formtab");
              } else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList.employee_previous !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.employee_previous !=
                undefined
              ) {
                dispatch(
                  SetPreviousEmployeeID(
                    state.EmployeeProfile.EmployeeProfileList.employee_previous
                      .id,
                  ),
                );

                navigate("/formtab");
              } else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList.employee_previous ==
                "" &&
                state.EmployeeProfile.EmployeeProfileList.employee_previous ==
                null &&
                state.EmployeeProfile.EmployeeProfileList.education_details !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.education_details !=
                undefined
              ) {
                dispatch(SetPreviousEmployeeID(""));

                if (state.FormsIDList.PreviousempID == "") {
                  navigate("/formtab");
                }
              } else if (state.NumberCounts.Editable == 2) {
                toast.error(
                  ` ${"The Previous Employment Details form can only be filled after the Education form is completed"} `,
                  {
                    position: toast.POSITION.TOP_RIGHT,
                  },
                );
              } else if (state.NumberCounts.Editable == 1) {
                toast.error(
                  ` ${"Previous Employment Details form is not filled"} `,
                  {
                    position: toast.POSITION.TOP_RIGHT,
                  },
                );
              }
              dispatch(SetActiveTabs(6));
            }}
          >
            <div className="card">
              <div className="card-body EmployeeCardBody">
                <div className="WIthPendingStatus">
                  <h5>Previous Employment Details</h5>
                  <div className="ICONS">
                    <img
                      src={
                        PreviouEmp
                          ? correctIcons
                          : state.EmployeeProfile.EmployeeProfileList == ""
                            ? ""
                            : Pending
                      }
                    />
                    <img src={ArrowIcons} />
                  </div>
                </div>
                <p>Your’s Previous Employment Details</p>
              </div>
            </div>
          </div>

          {/* --------------------------_FAMLIY____DETAILS----------------------------------------- */}

          {/* <div
            className="col-md-3 Cards"
            disabled={
              state.EmployeeProfile.EmployeeProfileList.family_details == null
            }
            onClick={(e) => {
              if (
                state.EmployeeProfile.EmployeeProfileList.family_details !=
                  null &&
                state.EmployeeProfile.EmployeeProfileList.family_details !=
                  undefined &&
                state.NumberCounts.Editable != 2
              ) {
                dispatch(
                  setfamliydetailsid(
                    state.EmployeeProfile.EmployeeProfileList.family_details.id
                  )
                );

                navigate("/formtab");
              } else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList.family_details !=
                  null &&
                state.EmployeeProfile.EmployeeProfileList.family_details !=
                  undefined
              ) {
                dispatch(
                  setfamliydetailsid(
                    state.EmployeeProfile.EmployeeProfileList.family_details.id
                  )
                );
                navigate("/formtab");
              } else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList == "" &&
                state.EmployeeProfile.EmployeeProfileList == undefined
              ) {
                dispatch(setfamliydetailsid(""));

                if (state.FormsIDList.FamilyDetailsId == "") {
                  navigate("/formtab");
                }
              } else {
                toast.error(` ${"Family Details form is not filled"} `, {
                  position: toast.POSITION.TOP_RIGHT,
                });
              }

              dispatch(SetActiveTabs(7));
            }}
          >
            <div className="card">
              <div className="card-body">
                <div className="WIthPendingStatus">
                  <h5>Family Details</h5>
                  <div className="ICONS">
                    <img
                      src={
                        FamlityDetails
                          ? correctIcons
                          : state.EmployeeProfile.EmployeeProfileList == ""
                          ? ""
                          : Pending
                      }
                    />
                    <img src={ArrowIcons} />
                  </div>
                </div>
                <p>Enter Your Family Details</p>
              </div>
            </div>
          </div> */}

          {/* --------------------------------------------------DECLARATION----FORM---------------------------- */}

          <div
            className="col-md-3 Cards"
            disabled={
              state.EmployeeProfile.EmployeeProfileList.declaration_form == null
            }
            onClick={(e) => {
              if (
                state.EmployeeProfile.EmployeeProfileList.declaration_form !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.declaration_form !=
                undefined &&
                state.NumberCounts.Editable != 2
              ) {
                dispatch(
                  SetDeclarationId(
                    state.EmployeeProfile.EmployeeProfileList.declaration_form
                      .id,
                  ),
                );

                navigate("/formtab");
              } else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList.declaration_form !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.declaration_form !=
                undefined
              ) {
                dispatch(
                  SetDeclarationId(
                    state.EmployeeProfile.EmployeeProfileList.declaration_form
                      .id,
                  ),
                );
                navigate("/formtab");
              } else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList.declaration_form ==
                null &&
                state.EmployeeProfile.EmployeeProfileList.declaration_form ==
                undefined &&
                state.EmployeeProfile.EmployeeProfileList.employee_previous !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.employee_previous !=
                undefined
                // state.EmployeeProfile.EmployeeProfileList != "" &&
                // state.EmployeeProfile.EmployeeProfileList.declaration_form ==
                //   null
              ) {
                dispatch(SetDeclarationId(""));

                if (
                  state.FormsIDList.FamilyDetailsId == ""
                  // state.EmployeeProfile.EmployeeProfileList.declaration_form ==
                  //   null
                ) {
                  navigate("/formtab");
                }
              } else if (state.NumberCounts.Editable == 2) {
                toast.error(
                  ` ${"The Decalaraion form can only be filled after the Previous Employment Details form is completed"} `,
                  {
                    position: toast.POSITION.TOP_RIGHT,
                  },
                );
              } else if (state.NumberCounts.Editable == 1) {
                toast.error(` ${"Decalaraion form is not filled"} `, {
                  position: toast.POSITION.TOP_RIGHT,
                });
              }
              dispatch(SetActiveTabs(8));
            }}
          >
            <div className="card">
              <div className="card-body EmployeeCardBody">
                <div className="WIthPendingStatus">
                  <h5>Declaration Form</h5>
                  <div className="ICONS">
                    <img
                      src={
                        Delaration
                          ? correctIcons
                          : state.EmployeeProfile.EmployeeProfileList == ""
                            ? ""
                            : Pending
                      }
                    />
                    <img src={ArrowIcons} />
                  </div>
                </div>
                <p>Form-11, Enter Your Details</p>
              </div>
            </div>
          </div>

          {/* ----------------------ESI-----Form----------------------- */}

          <div
            className="col-md-3 Cards"
            disabled={
              state.EmployeeProfile.EmployeeProfileList.esi_form == null
            }
            onClick={(e) => {
              if (
                state.EmployeeProfile.EmployeeProfileList.esi_form != null &&
                state.EmployeeProfile.EmployeeProfileList.esi_form !=
                undefined &&
                state.NumberCounts.Editable != 2
              ) {
                dispatch(
                  SetEsiFormIdActions(
                    state.EmployeeProfile.EmployeeProfileList.esi_form.id,
                  ),
                );

                navigate("/formtab");
              } //---reaad--only
              else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList.esi_form != null &&
                state.EmployeeProfile.EmployeeProfileList.esi_form != undefined
              ) {
                dispatch(
                  SetEsiFormIdActions(
                    state.EmployeeProfile.EmployeeProfileList.esi_form.id,
                  ),
                );

                navigate("/formtab");
              }
              ///edit---or--view
              else if (
                state.NumberCounts.Editable == 2 &&
                state.EmployeeProfile.EmployeeProfileList.esi_form == null &&
                state.EmployeeProfile.EmployeeProfileList.esi_form ==
                undefined &&
                state.EmployeeProfile.EmployeeProfileList.declaration_form !=
                null &&
                state.EmployeeProfile.EmployeeProfileList.declaration_form !=
                undefined
                // state.EmployeeProfile.EmployeeProfileList != "" &&
                // state.EmployeeProfile.EmployeeProfileList.esi_form == null
              ) {
                dispatch(SetEsiFormIdActions(""));
                if (
                  state.FormsIDList.ESIFormsid == ""
                  //  state.EmployeeProfile.EmployeeProfileList.esi_form == null
                ) {
                  navigate("/formtab");
                }
              } else if (state.NumberCounts.Editable == 2) {
                toast.error(
                  ` ${"The ESI form can only be filled after the declaration form is completed"} `,
                  {
                    position: toast.POSITION.TOP_RIGHT,
                  },
                );
              }

              // else if (
              //   state.NumberCounts.Editable == 2 &&
              //   state.EmployeeProfile.EmployeeProfileList == "" &&
              //   state.EmployeeProfile.EmployeeProfileList == undefined
              // ) {
              //   dispatch(SetEsiFormIdActions(""));
              //   if (state.FormsIDList.ESIFormsid == "") {
              //     navigate("/formtab");
              //   }
              // }

              //   dispatch(SetActiveTabs(9));
              else if (state.NumberCounts.Editable == 1) {
                toast.error(` ${"ESI  form is not filled"} `, {
                  position: toast.POSITION.TOP_RIGHT,
                });
              }
              dispatch(SetActiveTabs(9));
            }}
          >
            <div className="card">
              <div className="card-body EmployeeCardBody">
                <div className="WIthPendingStatus">
                  <h5>ESI Form</h5>
                  <div className="ICONS">
                    <img
                      src={
                        ESiForm
                          ? correctIcons
                          : state.EmployeeProfile.EmployeeProfileList == ""
                            ? ""
                            : Pending
                      }
                    />
                    <img src={ArrowIcons} />
                  </div>
                </div>
                <p>Form-2, Enter Your Details </p>
              </div>
            </div>
          </div>

          {/* -------Documents----- */}
          {state.EmployeeProfile.EmployeeProfileList != "" ? (
            <div
              className="col-md-3 Cards"
              disabled={
                state.EmployeeProfile.EmployeeProfileList.esi_form == null
              }
            >
              <div className="card">
                <div
                  className="card-body EmployeeCardBody"
                  onClick={(e) => {
                    navigate("/supportdocuments");
                  }}
                >
                  <div className="WIthPendingStatus">
                    <h5>Upload Documents</h5>
                    <div className="ICONS">
                      <img src={ArrowIcons} />
                    </div>
                  </div>
                  <p> Upload Your Documents </p>
                </div>
              </div>
            </div>
          ) : null}

          {state.NumberCounts.Editable == 1 ? (
            <>
              <div className="col-12 Filters CardDetailsOFOnboard">
                <h3>Onboard Details </h3>
              </div>

              {state.ClientBranchIDs.SUBROLE == 0 ? (
                <>
                  <div
                    className="col-md-3 Cards"
                    disabled={true}
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="card onboardingCards">
                      <div
                        className={`card-body  OnboardCardDetails  ${Onboarder.length > 1 ? "ForScroll" : ""}`}
                      >
                        <span className="OnboardeHeader">Onboard</span>

                        {Onboarder.length > 0 ? (
                          <>
                            {Onboarder.map((item) => {
                              const dateString = item.Createdate;
                              const dateObject = new Date(dateString);
                              const hours = dateObject.getHours();
                              const minutes = dateObject.getMinutes();
                              const seconds = dateObject.getSeconds();
                              const amOrPm = hours >= 12 ? "PM" : "AM";
                              const twelveHourFormat = hours % 12 || 12;

                              const formattedMinutes =
                                minutes < 10 ? `0${minutes}` : minutes;

                              const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                              return (
                                <>
                                  <div className="EachPayroll">
                                    <h5>
                                      <span>Name : </span>
                                      {capitalizeFirstLetter(item.name)}
                                    </h5>
                                    {/* <h5>
                                <span>Status : </span>
                                {capitalizeFirstLetter(item.status)}
                              </h5> */}

                                    <h5>
                                      <span>Date : </span>
                                      {item.Createdate.slice(0, 10) +
                                        " " +
                                        formattedTime}
                                    </h5>
                                  </div>
                                </>
                              );
                            })}
                          </>
                        ) : (
                          <>
                            <div className="EachPayroll text-center">
                              <p>Awaiting for Onboard</p>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-md-3 Cards"
                    disabled={true}
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="card onboardingCards ">
                      <div
                        className={`card-body  OnboardCardDetails ${Payroll.length > 1 ? "ForScroll" : ""}`}
                      >
                        <span className="OnboardeHeader">Payroll</span>
                        {Payroll.length > 0 ? (
                          <>
                            {Payroll.map((item) => {
                              const dateString = item.Createdate;
                              const dateObject = new Date(dateString);
                              const hours = dateObject.getHours();
                              const minutes = dateObject.getMinutes();
                              const seconds = dateObject.getSeconds();
                              const amOrPm = hours >= 12 ? "PM" : "AM";
                              const twelveHourFormat = hours % 12 || 12;

                              const formattedMinutes =
                                minutes < 10 ? `0${minutes}` : minutes;

                              const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                              return (
                                <>
                                  <div className="EachPayroll">
                                    <h5>
                                      <span>Name : </span>
                                      {capitalizeFirstLetter(item.name)}
                                    </h5>
                                    <h5>
                                      <span>Status : </span>
                                      {capitalizeFirstLetter(item.status)}
                                    </h5>
                                    {item.status != "approved" ? (
                                      <h5 className="Decline">
                                        <span>Reason:</span>
                                        {item.reason == null
                                          ? "  --"
                                          : " " + item.reason}
                                      </h5>
                                    ) : null}

                                    <h5>
                                      <span>Date : </span>
                                      {item.Createdate.slice(0, 10) +
                                        " " +
                                        formattedTime}
                                    </h5>
                                  </div>
                                </>
                              );
                            })}
                          </>
                        ) : (
                          <>
                            <div className="EachPayroll text-center">
                              <p>Awaiting for payroll</p>
                            </div>
                          </>
                        )}

                        {/* {Payroll.length > 0 ? (
                    <p
                      className="ViewButton"
                      style={{ padding: "10px", display: "flex" }}
                    >
                      <button >View</button>
                    </p>
                  ) : null} */}
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-md-3 Cards"
                    disabled={true}
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="card onboardingCards">
                      <div
                        className={`card-body  OnboardCardDetails  ${Rm.length > 1 ? "ForScroll" : ""}`}
                      >
                        <span className="OnboardeHeader">RM</span>
                        <>
                          {Rm.length > 0 ? (
                            <>
                              {Rm.map((item) => {
                                const dateString = item.Createdate;
                                const dateObject = new Date(dateString);
                                const hours = dateObject.getHours();
                                const minutes = dateObject.getMinutes();
                                const seconds = dateObject.getSeconds();
                                const amOrPm = hours >= 12 ? "PM" : "AM";
                                const twelveHourFormat = hours % 12 || 12;

                                const formattedMinutes =
                                  minutes < 10 ? `0${minutes}` : minutes;

                                const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                                return (
                                  <>
                                    <div className="EachPayroll">
                                      <h5>
                                        <span>Name : </span>
                                        {capitalizeFirstLetter(item.name)}
                                      </h5>
                                      <h5>
                                        <span>Status : </span>
                                        {capitalizeFirstLetter(item.status)}
                                      </h5>
                                      {item.status != "approved" ? (
                                        <h5 className="Decline">
                                          <span>Reason:</span>
                                          {item.reason == null
                                            ? "  --"
                                            : " " + item.reason}
                                        </h5>
                                      ) : null}
                                      <h5>
                                        <span>Date : </span>
                                        {item.Createdate.slice(0, 10) +
                                          " " +
                                          formattedTime}
                                      </h5>
                                    </div>
                                  </>
                                );
                              })}
                            </>
                          ) : (
                            <>
                              <div
                                className={`EachPayroll ${ManagerList != "" && Rm.length == 0
                                  ? ""
                                  : "text-center"
                                  }`}
                              >
                                {ManagerList != "" && Rm.length == 0 ? (
                                  <div className="EachPayroll">
                                    <h5>
                                      <span>Name : </span>
                                      {capitalizeFirstLetter(ManagerList)}
                                    </h5>
                                  </div>
                                ) : (
                                  <p className="text-center">
                                    Awaiting for Rm{" "}
                                  </p>
                                )}
                              </div>
                            </>
                          )}
                        </>
                      </div>
                    </div>
                  </div>
                  {organization?.organization?.id ==
                    "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                      <div
                        className="col-md-3 Cards"
                        disabled={true}
                        style={{ cursor: "not-allowed" }}
                      >
                        <div className="card onboardingCards">
                          <div
                            className={`card-body  OnboardCardDetails  ${hrApproval.length > 1 ? "ForScroll" : ""}`}
                          >
                            <span className="OnboardeHeader">HR</span>
                            <>
                              {hrApproval.length > 0 ? (
                                <>
                                  {hrApproval.map((item) => {
                                    const dateString = item.Createdate;
                                    const dateObject = new Date(dateString);
                                    const hours = dateObject.getHours();
                                    const minutes = dateObject.getMinutes();
                                    const seconds = dateObject.getSeconds();
                                    const amOrPm = hours >= 12 ? "PM" : "AM";
                                    const twelveHourFormat = hours % 12 || 12;

                                    const formattedMinutes =
                                      minutes < 10 ? `0${minutes}` : minutes;

                                    const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                                    return (
                                      <>
                                        <div className="EachPayroll">
                                          <h5>
                                            <span>Name : </span>
                                            {capitalizeFirstLetter(item.name)}
                                          </h5>
                                          <h5>
                                            <span>Status : </span>
                                            {capitalizeFirstLetter(item.status)}
                                          </h5>
                                          {item.status != "approved" ? (
                                            <h5 className="Decline">
                                              <span>Reason:</span>
                                              {item.reason == null
                                                ? "  --"
                                                : " " + item.reason}
                                            </h5>
                                          ) : null}
                                          <h5>
                                            <span>Date : </span>
                                            {item.Createdate.slice(0, 10) +
                                              " " +
                                              formattedTime}
                                          </h5>
                                        </div>
                                      </>
                                    );
                                  })}
                                </>
                              ) : (
                                <>
                                  <div className="EachPayroll text-center">
                                    <p>Awaiting for HR</p>
                                  </div>
                                </>
                              )}
                            </>
                          </div>
                        </div>
                      </div>
                    )}
                </>
              ) : (
                <>
                  {state.ClientBranchIDs.SUBROLE == 1 ? (
                    <>
                      <div
                        className="col-md-3 Cards"
                        disabled={true}
                        style={{ cursor: "not-allowed" }}
                      >
                        <div className="card onboardingCards">
                          <div
                            className={`card-body  OnboardCardDetails ${Onboarder.length > 1 ? "ForScroll" : ""}`}
                          >
                            <span className="OnboardeHeader">Onboard</span>

                            {Onboarder.length > 0 ? (
                              <>
                                {Onboarder.map((item) => {
                                  const dateString = item.Createdate;
                                  const dateObject = new Date(dateString);
                                  const hours = dateObject.getHours();
                                  const minutes = dateObject.getMinutes();
                                  const seconds = dateObject.getSeconds();
                                  const amOrPm = hours >= 12 ? "PM" : "AM";
                                  const twelveHourFormat = hours % 12 || 12;

                                  const formattedMinutes =
                                    minutes < 10 ? `0${minutes}` : minutes;

                                  const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                                  return (
                                    <>
                                      <div className="EachPayroll">
                                        <h5>
                                          <span>Name: </span>
                                          {capitalizeFirstLetter(item.name)}
                                        </h5>
                                        {/* <h5>
                                <span>Status : </span>
                                {capitalizeFirstLetter(item.status)}
                              </h5> */}

                                        <h5>
                                          <span>Date : </span>
                                          {item.Createdate.slice(0, 10) +
                                            " " +
                                            formattedTime}
                                        </h5>
                                      </div>
                                    </>
                                  );
                                })}
                              </>
                            ) : (
                              <>
                                <div className="EachPayroll text-center">
                                  <p>Awaiting for Onboard</p>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>

                      <div
                        className="col-md-3 Cards"
                        disabled={true}
                        style={{ cursor: "not-allowed" }}
                      >
                        <div className="card onboardingCards ">
                          <div
                            className={`card-body  OnboardCardDetails ${Payroll.length > 1 ? "ForScroll" : ""}`}
                          >
                            <span className="OnboardeHeader">Payroll</span>
                            {Payroll.length > 0 ? (
                              <>
                                {Payroll.map((item) => {
                                  const dateString = item.Createdate;
                                  const dateObject = new Date(dateString);
                                  const hours = dateObject.getHours();
                                  const minutes = dateObject.getMinutes();
                                  const seconds = dateObject.getSeconds();
                                  const amOrPm = hours >= 12 ? "PM" : "AM";
                                  const twelveHourFormat = hours % 12 || 12;

                                  const formattedMinutes =
                                    minutes < 10 ? `0${minutes}` : minutes;

                                  const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                                  return (
                                    <>
                                      <div className="EachPayroll">
                                        <h5>
                                          <span>Name : </span>
                                          {capitalizeFirstLetter(item.name)}
                                        </h5>
                                        <h5>
                                          <span>Status : </span>
                                          {capitalizeFirstLetter(item.status)}
                                        </h5>
                                        {item.status != "approved" ? (
                                          <h5 className="Decline">
                                            <span>Reason:</span>
                                            {item.reason == null
                                              ? "  --"
                                              : " " + item.reason}
                                          </h5>
                                        ) : null}

                                        <h5>
                                          <span>Date : </span>
                                          {item.Createdate.slice(0, 10) +
                                            " " +
                                            formattedTime}
                                        </h5>
                                      </div>
                                    </>
                                  );
                                })}
                              </>
                            ) : (
                              <>
                                <div className="EachPayroll text-center">
                                  <p>Awaiting for payroll</p>
                                </div>
                              </>
                            )}

                            {/* {Payroll.length > 0 ? (
                    <p
                      className="ViewButton"
                      style={{ padding: "10px", display: "flex" }}
                    >
                      <button >View</button>
                    </p>
                  ) : null} */}
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-3 Cards"
                        disabled={true}
                        style={{ cursor: "not-allowed" }}
                      >
                        <div className="card onboardingCards">
                          <div
                            className={`card-body  OnboardCardDetails ${Rm.length > 1 ? "ForScroll" : ""}`}
                          >
                            <span className="OnboardeHeader">RM</span>
                            <>
                              {Rm.length > 0 ? (
                                <>
                                  {Rm.map((item) => {
                                    const dateString = item.Createdate;
                                    const dateObject = new Date(dateString);
                                    const hours = dateObject.getHours();
                                    const minutes = dateObject.getMinutes();
                                    const seconds = dateObject.getSeconds();
                                    const amOrPm = hours >= 12 ? "PM" : "AM";
                                    const twelveHourFormat = hours % 12 || 12;

                                    const formattedMinutes =
                                      minutes < 10 ? `0${minutes}` : minutes;

                                    const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                                    return (
                                      <>
                                        <div className="EachPayroll">
                                          <h5>
                                            <span>Name : </span>
                                            {capitalizeFirstLetter(item.name)}
                                          </h5>
                                          <h5>
                                            <span>Status : </span>
                                            {capitalizeFirstLetter(item.status)}
                                          </h5>
                                          {item.status != "approved" ? (
                                            <h5 className="Decline">
                                              <span>Reason:</span>
                                              {item.reason == null
                                                ? "  --"
                                                : " " + item.reason}
                                            </h5>
                                          ) : null}
                                          <h5>
                                            <span>Date : </span>
                                            {item.Createdate.slice(0, 10) +
                                              " " +
                                              formattedTime}
                                          </h5>
                                        </div>
                                      </>
                                    );
                                  })}
                                </>
                              ) : (
                                <>
                                  <div
                                    className={`EachPayroll ${ManagerList != "" && Rm.length == 0
                                      ? ""
                                      : "text-center"
                                      }`}
                                  >
                                    {ManagerList != "" && Rm.length == 0 ? (
                                      <div className="EachPayroll">
                                        <h5>
                                          <span>Name : </span>
                                          {capitalizeFirstLetter(ManagerList)}
                                        </h5>
                                      </div>
                                    ) : (
                                      <p className="text-center">
                                        Awaiting for Rm{" "}
                                      </p>
                                    )}
                                  </div>
                                </>
                              )}
                            </>
                          </div>
                        </div>
                      </div>
                      {organization?.organization?.id ==
                        "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                          <div
                            className="col-md-3 Cards"
                            disabled={true}
                            style={{ cursor: "not-allowed" }}
                          >
                            <div className="card onboardingCards">
                              <div
                                className={`card-body  OnboardCardDetails  ${hrApproval.length > 1 ? "ForScroll" : ""}`}
                              >
                                <span className="OnboardeHeader">HR</span>
                                <>
                                  {hrApproval.length > 0 ? (
                                    <>
                                      {hrApproval.map((item) => {
                                        const dateString = item.Createdate;
                                        const dateObject = new Date(dateString);
                                        const hours = dateObject.getHours();
                                        const minutes = dateObject.getMinutes();
                                        const seconds = dateObject.getSeconds();
                                        const amOrPm = hours >= 12 ? "PM" : "AM";
                                        const twelveHourFormat = hours % 12 || 12;

                                        const formattedMinutes =
                                          minutes < 10 ? `0${minutes}` : minutes;

                                        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                                        return (
                                          <>
                                            <div className="EachPayroll">
                                              <h5>
                                                <span>Name : </span>
                                                {capitalizeFirstLetter(item.name)}
                                              </h5>
                                              <h5>
                                                <span>Status : </span>
                                                {capitalizeFirstLetter(
                                                  item.status,
                                                )}
                                              </h5>
                                              {item.status != "approved" ? (
                                                <h5 className="Decline">
                                                  <span>Reason:</span>
                                                  {item.reason == null
                                                    ? "  --"
                                                    : " " + item.reason}
                                                </h5>
                                              ) : null}
                                              <h5>
                                                <span>Date : </span>
                                                {item.Createdate.slice(0, 10) +
                                                  " " +
                                                  formattedTime}
                                              </h5>
                                            </div>
                                          </>
                                        );
                                      })}
                                    </>
                                  ) : (
                                    <>
                                      <div className="EachPayroll text-center">
                                        <p>Awaiting for HR</p>
                                      </div>
                                    </>
                                  )}
                                </>
                              </div>
                            </div>
                          </div>
                        )}
                    </>
                  ) : (
                    <>
                      {state.ClientBranchIDs.SUBROLE == 3 ? (
                        <>
                          <div
                            className="col-md-3 Cards"
                            disabled={true}
                            style={{ cursor: "not-allowed" }}
                          >
                            <div className="card onboardingCards">
                              <div
                                className={`card-body  OnboardCardDetails ${Onboarder.length > 1 ? "ForScroll" : ""}`}
                              >
                                <span className="OnboardeHeader">Onboard</span>

                                {Onboarder.length > 0 ? (
                                  <>
                                    {Onboarder.map((item) => {
                                      const dateString = item.Createdate;
                                      const dateObject = new Date(dateString);
                                      const hours = dateObject.getHours();
                                      const minutes = dateObject.getMinutes();
                                      const seconds = dateObject.getSeconds();
                                      const amOrPm = hours >= 12 ? "PM" : "AM";
                                      const twelveHourFormat = hours % 12 || 12;

                                      const formattedMinutes =
                                        minutes < 10 ? `0${minutes}` : minutes;

                                      const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                                      return (
                                        <>
                                          <div className="EachPayroll">
                                            <h5>
                                              <span>Name : </span>
                                              {capitalizeFirstLetter(item.name)}
                                            </h5>
                                            {/* <h5>
                                <span>Status : </span>
                                {capitalizeFirstLetter(item.status)}
                              </h5> */}

                                            <h5>
                                              <span>Date : </span>
                                              {item.Createdate.slice(0, 10) +
                                                " " +
                                                formattedTime}
                                            </h5>
                                          </div>
                                        </>
                                      );
                                    })}
                                  </>
                                ) : (
                                  <>
                                    <div className="EachPayroll text-center">
                                      <p>Awaiting for Onboard</p>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>

                          <div
                            className="col-md-3 Cards"
                            disabled={true}
                            style={{ cursor: "not-allowed" }}
                          >
                            <div className="card onboardingCards">
                              <div
                                className={`card-body  OnboardCardDetails ${Payroll.length > 1 ? "ForScroll" : ""}`}
                              >
                                <span className="OnboardeHeader">Payroll</span>
                                {Payroll.length > 0 ? (
                                  <>
                                    {Payroll.map((item) => {
                                      const dateString = item.Createdate;
                                      const dateObject = new Date(dateString);
                                      const hours = dateObject.getHours();
                                      const minutes = dateObject.getMinutes();
                                      const seconds = dateObject.getSeconds();
                                      const amOrPm = hours >= 12 ? "PM" : "AM";
                                      const twelveHourFormat = hours % 12 || 12;

                                      const formattedMinutes =
                                        minutes < 10 ? `0${minutes}` : minutes;

                                      const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                                      return (
                                        <>
                                          <div className="EachPayroll">
                                            <h5>
                                              <span>Name : </span>
                                              {capitalizeFirstLetter(item.name)}
                                            </h5>
                                            <h5>
                                              <span>Status : </span>
                                              {capitalizeFirstLetter(
                                                item.status,
                                              )}
                                            </h5>
                                            {item.status != "approved" ? (
                                              <h5 className="Decline">
                                                <span>Reason:</span>
                                                {item.reason == null
                                                  ? "  --"
                                                  : " " + item.reason}
                                              </h5>
                                            ) : null}

                                            <h5>
                                              <span>Date : </span>
                                              {item.Createdate.slice(0, 10) +
                                                " " +
                                                formattedTime}
                                            </h5>
                                          </div>
                                        </>
                                      );
                                    })}
                                  </>
                                ) : (
                                  <>
                                    <div className="EachPayroll text-center">
                                      <p>Awaiting for payroll</p>
                                    </div>
                                  </>
                                )}

                                {/* {Payroll.length > 0 ? (
                    <p
                      className="ViewButton"
                      style={{ padding: "10px", display: "flex" }}
                    >
                      <button>View</button>
                    </p>
                  ) : null} */}
                              </div>
                            </div>
                          </div>

                          <div
                            className="col-md-3 Cards"
                            disabled={true}
                            style={{ cursor: "not-allowed" }}
                          >
                            <div className="card onboardingCards">
                              <div
                                className={`card-body  OnboardCardDetails ForScroll_if ${Rm.length > 1 ? "ForScroll" : ""}`}
                              >
                                <span className="OnboardeHeader">RM</span>
                                <>
                                  {Rm.length > 0 ? (
                                    <>
                                      {Rm.map((item) => {
                                        const dateString = item.Createdate;
                                        const dateObject = new Date(dateString);
                                        const hours = dateObject.getHours();
                                        const minutes = dateObject.getMinutes();
                                        const seconds = dateObject.getSeconds();
                                        const amOrPm =
                                          hours >= 12 ? "PM" : "AM";
                                        const twelveHourFormat =
                                          hours % 12 || 12;

                                        const formattedMinutes =
                                          minutes < 10
                                            ? `0${minutes}`
                                            : minutes;

                                        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                                        return (
                                          <>
                                            <div className="EachPayroll">
                                              <h5>
                                                <span>Name : </span>
                                                {capitalizeFirstLetter(
                                                  item.name,
                                                )}
                                              </h5>
                                              <h5>
                                                <span>Status : </span>
                                                {capitalizeFirstLetter(
                                                  item.status,
                                                )}
                                              </h5>
                                              {item.status != "approved" ? (
                                                <h5 className="Decline">
                                                  <span>Reason:</span>
                                                  {item.reason == null
                                                    ? "  --"
                                                    : " " + item.reason}
                                                </h5>
                                              ) : null}
                                              <h5>
                                                <span>Date : </span>
                                                {item.Createdate.slice(0, 10) +
                                                  " " +
                                                  formattedTime}
                                              </h5>
                                            </div>
                                          </>
                                        );
                                      })}
                                    </>
                                  ) : (
                                    <>
                                      <div
                                        className={`EachPayroll ${ManagerList != "" && Rm.length == 0
                                          ? ""
                                          : "text-center"
                                          }`}
                                      >
                                        {ManagerList != "" && Rm.length == 0 ? (
                                          <div className="EachPayroll">
                                            <h5>
                                              <span>Name : </span>
                                              {capitalizeFirstLetter(
                                                ManagerList,
                                              )}
                                            </h5>
                                          </div>
                                        ) : (
                                          <p className="text-center">
                                            Awaiting for Rm{" "}
                                          </p>
                                        )}
                                      </div>
                                    </>
                                  )}
                                </>
                              </div>
                            </div>
                          </div>
                          {organization?.organization?.id ==
                            "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                              <div
                                className="col-md-3 Cards"
                                disabled={true}
                                style={{ cursor: "not-allowed" }}
                              >
                                <div className="card onboardingCards">
                                  <div
                                    className={`card-body  OnboardCardDetails  ${hrApproval.length > 1 ? "ForScroll" : ""}`}
                                  >
                                    <span className="OnboardeHeader">HR</span>
                                    <>
                                      {hrApproval.length > 0 ? (
                                        <>
                                          {hrApproval.map((item) => {
                                            const dateString = item.Createdate;
                                            const dateObject = new Date(
                                              dateString,
                                            );
                                            const hours = dateObject.getHours();
                                            const minutes =
                                              dateObject.getMinutes();
                                            const seconds =
                                              dateObject.getSeconds();
                                            const amOrPm =
                                              hours >= 12 ? "PM" : "AM";
                                            const twelveHourFormat =
                                              hours % 12 || 12;

                                            const formattedMinutes =
                                              minutes < 10
                                                ? `0${minutes}`
                                                : minutes;

                                            const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                                            return (
                                              <>
                                                <div className="EachPayroll">
                                                  <h5>
                                                    <span>Name : </span>
                                                    {capitalizeFirstLetter(
                                                      item.name,
                                                    )}
                                                  </h5>
                                                  <h5>
                                                    <span>Status : </span>
                                                    {capitalizeFirstLetter(
                                                      item.status,
                                                    )}
                                                  </h5>
                                                  {item.status != "approved" ? (
                                                    <h5 className="Decline">
                                                      <span>Reason:</span>
                                                      {item.reason == null
                                                        ? "  --"
                                                        : " " + item.reason}
                                                    </h5>
                                                  ) : null}
                                                  <h5>
                                                    <span>Date : </span>
                                                    {item.Createdate.slice(
                                                      0,
                                                      10,
                                                    ) +
                                                      " " +
                                                      formattedTime}
                                                  </h5>
                                                </div>
                                              </>
                                            );
                                          })}
                                        </>
                                      ) : (
                                        <>
                                          <div className="EachPayroll text-center">
                                            <p>Awaiting for HR</p>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  </div>
                                </div>
                              </div>
                            )}
                        </>
                      ) : null}
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <div
                className=" col-12 Filters "
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {state.EmployeeProfile.EmployeeProfileList != "" &&
                  state.EmployeeProfile.EmployeeProfileList != null &&
                  state.EmployeeProfile.EmployeeProfileList != undefined &&
                  state.EmployeeProfile.EmployeeProfileList.is_declaration_form &&
                  state.EmployeeProfile.EmployeeProfileList.is_basic_info &&
                  state.EmployeeProfile.EmployeeProfileList.is_esi_form &&
                  state.EmployeeProfile.EmployeeProfileList
                    .is_previous_employee &&
                  state.EmployeeProfile.EmployeeProfileList
                    .is_education_details &&
                  state.EmployeeProfile.EmployeeProfileList.is_job_description &&
                  state.EmployeeProfile.EmployeeProfileList.is_address_details &&
                  state.EmployeeProfile.EmployeeProfileList.is_bank_details &&
                  state.EmployeeProfile.EmployeeProfileList.is_bank_details &&
                  state.NumberCounts.Editable != 1 &&
                  !state.EmployeeProfile.EmployeeProfileList.create_employee ? (
                  <button
                    className="btn ButtonCSS"
                    style={{
                      color: "#ffff",
                      background: "#EF4D39",
                    }}
                    onClick={(e) => {
                      HandleCreateEmployee(e);
                    }}
                  >
                    Create Employee
                  </button>
                ) : state.EmployeeProfile.EmployeeProfileList
                  .create_employee ? (
                  <>{/* <p></p> */}</>
                ) : null}
              </div>
            </>
          )}

          {state.NumberCounts.Editable == 1 && createEmployee ? (
            <>
              <div className="col-12 CardDetailsOFOnboard">
                <h3>Verification Status </h3>
              </div>

              <div
                className="col-md-3 Cards"
                disabled={true}
                style={{ cursor: "not-allowed" }}
              >
                <div className="card">
                  <div className="card-body EmployeeCardBody">
                    <div className="WIthPendingStatus">
                      <h5>WhatsApp Confirmation</h5>
                      <div className="ICONS">
                        <img src={whatsApp ? correctIcons : Pending} />
                        {/* <img src={ArrowIcons} /> */}
                      </div>
                    </div>
                    <p style={{ padding: "10px" }}>
                      {whatsApp
                        ? "The offer letter link has been sent to WhatsApp."
                        : "The offer letter link has not been sent to WhatsApp."}
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-md-3 Cards"
                disabled={true}
                style={{ cursor: "not-allowed" }}
              >
                <div className="card">
                  <div className="card-body EmployeeCardBody">
                    <div className="WIthPendingStatus">
                      <h5>Aadhaar Confirmation</h5>
                      <div className="ICONS">
                        <img src={idverificationsID ? correctIcons : Pending} />
                        {/* <img src={ArrowIcons} /> */}
                      </div>
                    </div>
                    <p style={{ padding: "10px" }}>
                      {idverificationsID
                        ? "Aadhaar is verified."
                        : "Aadhaar is not  verified"}
                    </p>
                  </div>
                </div>
              </div>

              <div
                className="col-md-3 Cards"
                disabled={true}
                style={{ cursor: "not-allowed" }}
              >
                <div className="card">
                  <div className="card-body EmployeeCardBody">
                    <div className="WIthPendingStatus">
                      <h5>Bank Account Confirmation</h5>
                      <div className="ICONS">
                        <img src={Bank ? correctIcons : Pending} />
                        {/* <img src={ArrowIcons} /> */}
                      </div>
                    </div>
                    <p>
                      {Bank
                        ? "A one rupee credit has been made to your bank account."
                        : "A one rupee credit has not been made to your bank account."}
                    </p>
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>
        <>
          {state.NumberCounts.Editable == 1 ? (
            <>
              {!state.ClientBranchIDs.StatusBtn &&
                createEmployee &&
                state.NumberCounts.Editable == 1 ? (
                <>
                  {/* {whatsApp ? ( */}

                  {Approvel ? (
                    ///----Approved--Employee-----------------
                    <div
                      className="col-12 Filters VerficationStatus IdVerificationsID ApprovedEmployee"
                      style={{
                        marginTop: "90px",
                      }}
                    >
                      {/* <span className="otp-status">
                  <input
                    type="checkbox"
                    id="otpCheckbox"
                    checked={whatsApp}
                    readOnly
                  />
                  <label
                    htmlFor="otpCheckbox"
                    className="custom-checkbox"
                  ></label>
                  <span
                    className="otp-message"
                    style={{
                      color: "#0FA402",
                      marginLeft: "10px",
                      fontSize: "19px",
                    }}
                  >
                    {whatsApp
                      ? "The offer letter link has been sent to WhatsApp."
                      : "The offer letter link has not been sent to WhatsApp."}
                  </span>
                </span> */}
                      {state.EmployeeProfile.EmployeeProfileList != "" &&
                        state.EmployeeProfile.EmployeeProfileList !=
                        undefined &&
                        state.EmployeeProfile.EmployeeProfileList?.client_id !=
                        null &&
                        state.EmployeeProfile.EmployeeProfileList?.client_id?.client_name
                          .toLowerCase()
                          ?.includes("sony") && (
                          <div className="Letter_exports">
                            <Lettersexports />
                          </div>
                        )}

                      <div>
                        <span style={{ color: "#F05739" }}>
                          Approved Employee
                        </span>
                      </div>
                    </div>
                  ) : (
                    <>
                      {!Approvel &&
                        state.ClientBranchIDs.SUBROLE != 3 &&
                        //!whatsApp ||
                        SubRoleList != 0 &&
                        state.ClientBranchIDs.SUBROLE == 1 &&
                        createEmployee &&
                        state.EmployeeProfile.EmployeeProfileList
                          .payroll_approved == true &&
                        state.EmployeeProfile.EmployeeProfileList
                          .create_employee == true &&
                        state.NumberCounts.Editable == 1 ? (
                        <div
                          className="col-12 VerficationStatus"
                          style={{
                            marginTop: "90px",
                            marginBottom: "20px",
                          }}
                        >
                          <button
                            className="Decline ButtonCSS"
                            //onClick={(e) => navigate("/employeeVerifylist")}
                            onClick={(e) => {
                              HandleDecline(e);
                            }}
                          >
                            {/* Decline */}
                            Reject
                          </button>

                          <button
                            className="verify ButtonCSS"
                            onClick={(e) => {
                              // HandleVerify(e);
                              HandleRMpay(e);
                            }}
                          >
                            {!RMADMIN
                              ? organization?.organization?.id ==
                                "11a8ab83-0669-4098-a453-ddb2a2e0c39e" &&
                                state.EmployeeProfile.EmployeeProfileList
                                  ?.payroll_approved
                                ? "Send Offer"
                                : "Approve"
                              : "Not approved yet."}
                          </button>
                          {organization?.organization?.id ==
                            "11a8ab83-0669-4098-a453-ddb2a2e0c39e" &&
                            state.EmployeeProfile.EmployeeProfileList
                              ?.is_pending &&
                            state.EmployeeProfile.EmployeeProfileList
                              ?.employee_sign_link_sent &&
                            state.EmployeeProfile.EmployeeProfileList
                              ?.payroll_approved && (
                              <button
                                className="verify ButtonCSS"
                                onClick={(e) => {
                                  e.preventDefault();
                                  let payload = {
                                    payload: {
                                      timeline_id:
                                        state.BasicFormCreated
                                          .BasciFormCreate == ""
                                          ? state.EmployeeProfile
                                            .EmployeeProfileList.id
                                          : state.BasicFormCreated
                                            .BasciFormCreate,
                                    },
                                  };
                                  dispatch(SetRemainderMailCallAction(payload));
                                }}
                                style={{
                                  backgroundColor: "#004fbf",
                                }}
                              >
                                {!RMADMIN &&
                                  organization?.organization?.id ==
                                  "11a8ab83-0669-4098-a453-ddb2a2e0c39e" &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    ?.is_pending &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    ?.employee_sign_link_sent &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    ?.payroll_approved &&
                                  "Remainder Mail"}
                              </button>
                            )}
                        </div>
                      ) : (
                        !Approvel &&
                        state.ClientBranchIDs.SUBROLE == 3 &&
                        //!whatsApp ||
                        SubRoleList != 0 &&
                        createEmployee &&
                        // state.EmployeeProfile.EmployeeProfileList.payroll_approved == true &&
                        state.EmployeeProfile.EmployeeProfileList
                          .create_employee == true &&
                        state.NumberCounts.Editable == 1 && (
                          <>
                            <div
                              className="col-12 VerficationStatus"
                              style={{
                                marginTop: "90px",
                                marginBottom: "20px",
                              }}
                            >
                              <button
                                className="Decline ButtonCSS"
                                //onClick={(e) => navigate("/employeeVerifylist")}
                                onClick={(e) => {
                                  HandleDecline(e);
                                }}
                              >
                                {/* Decline */}
                                Reject
                              </button>
                              <button
                                className="verify ButtonCSS"
                                onClick={(e) => {
                                  // HandleVerify(e);
                                  HandleRMpay(e);
                                }}
                              >
                                {!RMADMIN
                                  ? organization?.organization?.id ==
                                    "11a8ab83-0669-4098-a453-ddb2a2e0c39e" &&
                                    state.EmployeeProfile.EmployeeProfileList
                                      ?.payroll_approved
                                    ? "Send Offer"
                                    : "Approve"
                                  : "Not approved yet."}
                              </button>

                              {organization?.organization?.id ==
                                "11a8ab83-0669-4098-a453-ddb2a2e0c39e" &&
                                state.EmployeeProfile.EmployeeProfileList
                                  ?.is_pending &&
                                state.EmployeeProfile.EmployeeProfileList
                                  ?.employee_sign_link_sent &&
                                state.EmployeeProfile.EmployeeProfileList
                                  ?.payroll_approved && (
                                  <button
                                    className="verify ButtonCSS"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      let payload = {
                                        payload: {
                                          timeline_id:
                                            state.BasicFormCreated
                                              .BasciFormCreate == ""
                                              ? state.EmployeeProfile
                                                .EmployeeProfileList.id
                                              : state.BasicFormCreated
                                                .BasciFormCreate,
                                        },
                                      };
                                      dispatch(
                                        SetRemainderMailCallAction(payload),
                                      );
                                    }}
                                    style={{
                                      backgroundColor: "#004fbf",
                                    }}
                                  >
                                    {!RMADMIN &&
                                      organization?.organization?.id ==
                                      "11a8ab83-0669-4098-a453-ddb2a2e0c39e" &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        ?.is_pending &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        ?.employee_sign_link_sent &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        ?.payroll_approved &&
                                      "Remainder Mail"}
                                  </button>
                                )}
                            </div>
                          </>
                        )
                      )}
                    </>
                  )}
                </>
              ) : null}

              {SubRoleList == 0 &&
                state.EmployeeProfile.EmployeeProfileList != undefined &&
                state.EmployeeProfile.EmployeeProfileList != null &&
                !state.EmployeeProfile.EmployeeProfileList.payroll_approved &&
                // state.EmployeeProfile.EmployeeProfileList.is_decline == false && // added
                state.NumberCounts.Editable == 1 &&
                state.EmployeeProfile.EmployeeProfileList.create_employee ==
                true ? (
                <div
                  className="col-12 VerficationStatus"
                  style={{
                    marginTop: "90px",
                    marginBottom: "20px",
                  }}
                >
                  <button
                    className="Decline ButtonCSS"
                    //onClick={(e) => navigate("/employeeVerifylist")}
                    onClick={(e) => {
                      HandleDecline(e);
                    }}
                  >
                    {/* Decline */}
                    Reject
                  </button>
                  <button
                    className="verify ButtonCSS"
                    onClick={(e) => {
                      HandleVerify(e);
                    }}
                  >
                    {/* Verify */}
                    Approve
                  </button>
                </div>
              ) : null}
            </>
          ) : null}
        </>
      </div>
      {console.log(state.EmployeeProfile, "daslkdklakldklasd")}

      {open ? (
        // && state.pdfdownloadcall.PdfDownloadDatas !=""
        <PdfViwers
          token={token}
          show={open}
          setshow={setopen}
          pdfUrl={state.pdfdownloadcall.PdfDownloadDatas}
          SubRoleList={SubRoleList}
          Approvel={Approvel}
          createEmployee={createEmployee}
        />
      ) : null}
    </>
  );
};

export default EMployeeProfiles;
